<div class="modal-layer" [ngClass]="{ 'active':modal.open }">
    <div class="backdrop"></div>
    <div class="modal-sm" *ngIf="modal.cntx == 'add-office'">
        <div class="modal-ttl">Добавяне на офис</div>
        <div class="col-xl-12 col-lg-12 input-row">
            <span class="label">Адрес нa офис</span>
            <input type="text" placeholder="Въведете адрес на офис" [(ngModel)]="modal.obj.address" />
        </div>
        <div class="col-xl-12 col-lg-12 input-row">
            <span class="label">Телефон на офис</span>
            <input type="text" placeholder="Въведете телефон на офис" [(ngModel)]="modal.obj.phone" />
        </div>
        <div class="btn-line">
            <div class="btn back" (click)="closeModal()">Отказ</div>
            <div class="btn positive" [ngClass]="{ 'disabled':modal.obj.address.length == 0 || modal.obj.phone.length == 0 }" (click)="addOffice()">Добавяне</div>
        </div>
    </div>

    <div class="modal-sm" *ngIf="modal.cntx == 'edit-office'">
        <div class="modal-ttl">Промяна на офис</div>
        <div class="col-xl-12 col-lg-12 input-row">
            <span class="label">Адрес нa офис</span>
            <input type="text" placeholder="Въведете адрес на офис" [(ngModel)]="modal.obj.address" />
        </div>
        <div class="col-xl-12 col-lg-12 input-row">
            <span class="label">Телефон на офис</span>
            <input type="text" placeholder="Въведете телефон на офис" [(ngModel)]="modal.obj.phone" />
        </div>
        <div class="btn-line">
            <div class="btn back" (click)="closeModal()">Отказ</div>
            <div class="btn positive" [ngClass]="{ 'disabled':modal.obj.address.length == 0 || modal.obj.phone.length == 0 }"  (click)="editOffice()">Запис</div>
        </div>
    </div>

    <div class="modal-sm" *ngIf="modal.cntx == 'change-password'">
        <div class="modal-ttl">Смяна на парола</div>
        <div class="col-xl-12 col-lg-12 input-row">
            <span class="label">Стара парола <span style="color:red;float:right;font-size:10px" *ngIf="modal.obj.error">Въведената парола е грешна</span></span>
            <input type="password" placeholder="Въведете старата си парола" [(ngModel)]="modal.obj.old_password" />
        </div>
        <div class="col-xl-12 col-lg-12 input-row">
            <span class="label">Нова парола</span>
            <input type="password" placeholder="Въведете новата си парола" [(ngModel)]="modal.obj.new_password" />
        </div>
        <div class="btn-line">
            <div class="btn back" (click)="closeModal()">Отказ</div>
            <div class="btn positive" [ngClass]="{ 'disabled':modal.obj.old_password.length == 0 || modal.obj.new_password.length == 0 }" (click)="changePassword()">Запис</div>
        </div>
    </div>

    <div class="modal-lg" *ngIf="modal.cntx == 'importing-contracts'">
        <div style="width:100%;height:100%;float:left;" *ngIf="modal.obj.step == 1">
            <div class="modal-ttl">Импорт на търгове - Стъпка 1 / 3</div>
            <div class="files-selectors">
                <div class="file-selector" style="width: 224px;margin-left: 4%;" [ngClass]="{ 'selected':modal.obj.first_file_loaded }" (click)="openFileManagementFirst($event)">
                    <span *ngIf="!modal.obj.first_file_loaded">Моля изберете файл за Монтаж ПГО</span>
                    <span *ngIf="modal.obj.first_file_loaded" style="color: #0db80d;font-weight: bold;">Успешно зареден файл</span>
                </div>
                <div class="file-selector" style="width: 224px;margin-left: 4%;" [ngClass]="{ 'selected':modal.obj.second_file_loaded }" (click)="openFileManagementSecond($event)">
                    <span *ngIf="!modal.obj.second_file_loaded">Моля изберете файл за Справка</span>
                    <span *ngIf="modal.obj.second_file_loaded" style="color: #0db80d;font-weight: bold;">Успешно зареден файл</span>
                </div>
                <div class="file-selector" style="width: 224px;margin-left: 4%;" [ngClass]="{ 'selected':modal.obj.third_file_loaded }" (click)="openFileManagementAcList($event)">
                    <span *ngIf="!modal.obj.third_file_loaded">Ако желате да впишете серийни номера, изберете файл със серийни номер</span>
                    <span *ngIf="modal.obj.third_file_loaded" style="color: #0db80d;font-weight: bold;">Успешно зареден файл</span>
                </div>
                <input type="file" id="document-upload1" style="display:none;" accept=".xlsx" (change)="onFileChangeFirst($event)" />
                <input type="file" id="document-upload2" style="display:none;" accept=".xlsx" (change)="onFileChangeSecond($event)" />
                <input type="file" id="document-upload3" style="display:none;" accept=".xlsx" (change)="onFileChangeAcList($event)" />
            </div>
            <div class="btn-line" style="position:absolute;bottom:20px;">
                <div class="btn back" (click)="closeModal()">Отказ</div>
                <div class="btn positive" (click)="modal.obj.step = 2" (click)="PrepareContracts()" [ngClass]="{ 'disabled':!modal.obj.first_file_loaded || !modal.obj.second_file_loaded }">Напред</div>
            </div>
        </div>
        <div style="width:100%;height:100%;float:left;" *ngIf="modal.obj.step == 2">
            <div class="modal-ttl">Импорт на търгове - Стъпка 2 / 3</div>
            <table class="products-table">
                <thead>
                    <tr>
                        <th>Климатик</th>
                        <th>Модел от ТЕМПЕКС</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let product of modal.obj.available_products">
                        <td style="text-align:center;">{{ product.type }} BTU</td>
                        <td>
                            <input type="text" [(ngModel)]="product.label" />
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="btn-line" style="position:absolute;bottom:20px;">
                <div class="btn back" (click)="closeModal()">Отказ</div>
                <div class="btn positive" [ngClass]="{ 'disabled':!ReturnAreAllProductsFilled() }" (click)="NextPrepareContracts()">Напред</div>
            </div>
        </div>
        <div style="width:100%;height:100%;float:left;" *ngIf="modal.obj.step == 3">
            <div class="modal-ttl">Импорт на търгове - Стъпка 3 / 3</div>
            <table class="products-table">
                <thead>
                    <tr>
                        <th>Гаранционен срок</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>
                            <input style="width: 20%;
                            margin-left: 20px;
                            height: 30px;
                            border-radius: 5px;
                            border: 1px solid gray;" type="text" placeholder="Гаранционен срок" [(ngModel)]="modal.obj.warranty_period"  />
                            <span style="font-size: 14px;
                            margin-left: 10px;">месеца</span>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="button-group">
                <div class="button" (click)="GenerateContracts()">Генериране на протоколи</div>
                <div class="button" (click)="GenerateWarranties()">Генериране на гар.карти</div>
            </div>
            <div class="hint-group">
                <div class="hint">
                    <span *ngIf="contracts.length != 0">Вече сте генерирали протоколи, ако желаете да ги прегенерирате, натиснете бутона отново!</span>
                </div>
                <div class="hint" >
                    <span *ngIf="warranties.length != 0">Вече сте генерирали гаранционни карти, ако желаете да ги прегенерирате, натиснете бутона отново!</span>
                </div>
            </div>
            <div class="btn-line" style="position:absolute;bottom:20px;">
                <div class="btn positive" style="width:99%;"  [ngClass]="{ 'disabled':!ReturnAreAllProductsFilled() }" (click)="closeModal()">Приключи</div>
            </div>
        </div>
    </div>

    <div class="modal-lg" *ngIf="modal.cntx == 'importing-contracts-sofia'">
        <div style="width:100%;height:100%;float:left;" *ngIf="modal.obj.step == 1">
            <div class="modal-ttl">Импорт на търгове (София профилактика) - Стъпка 1 / 3</div>
            <div class="files-selectors">
                <div class="file-selector" style="width: 224px;margin-left: 4%;" [ngClass]="{ 'selected':modal.obj.first_file_loaded }" (click)="openFileManagementFirst($event)">
                    <span *ngIf="!modal.obj.first_file_loaded">Моля изберете файл за Монтаж ПГО</span>
                    <span *ngIf="modal.obj.first_file_loaded" style="color: #0db80d;font-weight: bold;">Успешно зареден файл</span>
                </div>
                <div class="file-selector" style="width: 224px;margin-left: 4%;" [ngClass]="{ 'selected':modal.obj.second_file_loaded }" (click)="openFileManagementSecond($event)">
                    <span *ngIf="!modal.obj.second_file_loaded">Моля изберете файл за Справка</span>
                    <span *ngIf="modal.obj.second_file_loaded" style="color: #0db80d;font-weight: bold;">Успешно зареден файл</span>
                </div>
                <!-- <div class="file-selector" style="width: 224px;margin-left: 4%;" [ngClass]="{ 'selected':modal.obj.third_file_loaded }" (click)="openFileManagementAcList($event)">
                    <span *ngIf="!modal.obj.third_file_loaded">Ако желате да впишете серийни номера, изберете файл със серийни номер</span>
                    <span *ngIf="modal.obj.third_file_loaded" style="color: #0db80d;font-weight: bold;">Успешно зареден файл</span>
                </div> -->
                <input type="file" id="document-upload1" style="display:none;" accept=".xlsx" (change)="onFileChangeFirst($event)" />
                <input type="file" id="document-upload2" style="display:none;" accept=".xlsx" (change)="onFileChangeSecond($event)" />
                <!-- <input type="file" id="document-upload3" style="display:none;" accept=".xlsx" (change)="onFileChangeAcList($event)" /> -->
            </div>
            <div class="btn-line" style="position:absolute;bottom:20px;">
                <div class="btn back" (click)="closeModal()">Отказ</div>
                <div class="btn positive" (click)="modal.obj.step = 2" (click)="PrepareContracts()" [ngClass]="{ 'disabled':!modal.obj.first_file_loaded || !modal.obj.second_file_loaded }">Напред</div>
            </div>
        </div>
        <div style="width:100%;height:100%;float:left;" *ngIf="modal.obj.step == 2">
            <div class="modal-ttl">Импорт на търгове (София профилактика) - Стъпка 2 / 3</div>
            <table class="products-table">
                <thead>
                    <tr>
                        <th>Климатик</th>
                        <th>Модел от ТЕМПЕКС</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let product of modal.obj.available_products">
                        <td style="text-align:center;">{{ product.type }} BTU</td>
                        <td>
                            <input type="text" [(ngModel)]="product.label" />
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="btn-line" style="position:absolute;bottom:20px;">
                <div class="btn back" (click)="closeModal()">Отказ</div>
                <div class="btn positive" [ngClass]="{ 'disabled':!ReturnAreAllProductsFilled() }" (click)="NextPrepareContracts()">Напред</div>
            </div>
        </div>
        <div style="width:100%;height:100%;float:left;" *ngIf="modal.obj.step == 3">
            <div class="modal-ttl">Импорт на търгове (София профилактика) - Стъпка 3 / 3</div>
            <!-- <table class="products-table">
                <thead>
                    <tr>
                        <th>Гаранционен срок</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>
                            <input style="width: 20%;
                            margin-left: 20px;
                            height: 30px;
                            border-radius: 5px;
                            border: 1px solid gray;" type="text" placeholder="Гаранционен срок" [(ngModel)]="modal.obj.warranty_period"  />
                            <span style="font-size: 14px;
                            margin-left: 10px;">месеца</span>
                        </td>
                    </tr>
                </tbody>
            </table> -->
            <div class="button-group">
                <div class="button" (click)="GenerateProtocolsSofia()">Генериране на протоколи</div>
                <!-- <div class="button" (click)="GenerateWarranties()">Генериране на гар.карти</div> -->
            </div>
            <div class="hint-group">
                <div class="hint">
                    <span *ngIf="contracts.length != 0">Вече сте генерирали протоколи, ако желаете да ги прегенерирате, натиснете бутона отново!</span>
                </div>
                <!-- <div class="hint" >
                    <span *ngIf="warranties.length != 0">Вече сте генерирали гаранционни карти, ако желаете да ги прегенерирате, натиснете бутона отново!</span>
                </div> -->
            </div>
            <div class="btn-line" style="position:absolute;bottom:20px;">
                <div class="btn positive" style="width:99%;"  [ngClass]="{ 'disabled':!ReturnAreAllProductsFilled() }" (click)="closeModal()">Приключи</div>
            </div>
        </div>
    </div>

    <div class="modal-lg" *ngIf="modal.cntx == 'importing-contracts-burgas'">
        <div style="width:100%;height:100%;float:left;" *ngIf="modal.obj.step == 1">
            <div class="modal-ttl">Импорт на търг Бургас - Стъпка 1 / 2</div>
            <table class="products-table">
                <thead>
                    <tr>
                        <th>Климатик</th>
                        <th>Модел от ТЕМПЕКС</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let product of modal.obj.available_products">
                        <td style="text-align:center;">{{ product.description }}</td>
                        <td>
                            <input type="text" [(ngModel)]="product.label" />
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="btn-line" style="position:absolute;bottom:20px;">
                <div class="btn back" (click)="closeModal()">Отказ</div>
                <div class="btn positive" [ngClass]="{ 'disabled':!ReturnAreAllProductsFilled() }" (click)="modal.obj.step = 2">Напред</div>
            </div>
        </div>
        <div style="width:100%;height:100%;float:left;" *ngIf="modal.obj.step == 2">
            <div class="modal-ttl">Импорт на търг Бургас - Стъпка 2 / 2</div>
            <table class="products-table">
                <thead>
                    <tr>
                        <th>Гаранционен срок</th>
                        <th>Номер на договор</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>
                            <input style="width: 40%;
                            margin-left: 20px;
                            height: 30px;
                            border-radius: 5px;
                            border: 1px solid gray;" type="text" placeholder="Гаранционен срок" [(ngModel)]="modal.obj.warranty_period"  />
                            <span style="font-size: 14px;
                            margin-left: 10px;">месеца</span>
                        </td>
                        <td>
                            <input style="width: 90%;
                            margin-left: 20px;
                            height: 30px;
                            border-radius: 5px;
                            border: 1px solid gray;" type="text" placeholder="Номер на договор" [(ngModel)]="modal.obj.contract"  />
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="selector-group">
                <div class="select-group" (click)="SwitchSelectedSheet(i)" *ngFor="let sheet_name of modal.obj.sheets_names;let i = index" [ngClass]="{ 'active':modal.obj.selected_index_sheet == i }">{{ sheet_name }}</div>
            </div>

            <div class="note" *ngIf="modal.obj.contract.length == 0">
                <i class="icon"></i>
                <span>Въведете номер на документ, за да продължите</span>
            </div>
            <div class="button-group" *ngIf="modal.obj.contract.length > 0">
                <div class="button" style="width:calc(33% - 23px);" (click)="PrintBurgasProtocols()">Генериране на протоколи</div>
                <div class="button" style="width:calc(33% - 23px);" (click)="PrintBurgasWarranties()">Генериране на гар.карти</div>
                <div class="button" style="width:calc(33% - 23px);" (click)="PrintBurgasProfilaktika()">Генериране на профилактика</div>
            </div>
            <div class="hint-group"  *ngIf="modal.obj.contract.length > 0">
                <div class="hint" style="width:calc(33% - 23px);">
                    <span *ngIf="modal.obj.generated[this.modal.obj.selected_index_sheet].protocol">Вече сте генерирали протоколи, ако желаете да ги прегенерирате, натиснете бутона отново!</span>
                </div>
                <div class="hint" style="width:calc(33% - 23px);">
                    <span *ngIf="modal.obj.generated[this.modal.obj.selected_index_sheet].warranty">Вече сте генерирали гаранционни карти, ако желаете да ги прегенерирате, натиснете бутона отново!</span>
                </div>
                <div class="hint" style="width:calc(33% - 23px);">
                    <span *ngIf="modal.obj.generated[this.modal.obj.selected_index_sheet].profilaktika">Вече сте генерирали протокол за профилактика, ако желаете да ги прегенерирате, натиснете бутона отново!</span>
                </div>
            </div>
            <div class="btn-line" style="position:absolute;bottom:20px;" *ngIf="modal.obj.contract.length > 0">
                <div class="btn positive" style="width:99%;"  [ngClass]="{ 'disabled':!ReturnAreAllProductsFilled() }" (click)="closeModal()">Приключи</div>
            </div>
        </div>
    </div>

    <div class="modal-lg" *ngIf="modal.cntx == 'importing-contracts-burgas2026'">
        <div style="width:100%;height:100%;float:left;" *ngIf="modal.obj.step == 1">
            <div class="modal-ttl">Импорт на търг Бургас 2026 - Стъпка 1 / 2</div>
            <table class="products-table">
                <thead>
                    <tr>
                        <th>Климатик</th>
                        <th>Модел от ТЕМПЕКС</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let product of modal.obj.available_products">
                        <td style="text-align:center;">{{ product.description }}</td>
                        <td>
                            <input type="text" [(ngModel)]="product.label" />
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="btn-line" style="position:absolute;bottom:20px;">
                <div class="btn back" (click)="closeModal()">Отказ</div>
                <div class="btn positive" [ngClass]="{ 'disabled':!ReturnAreAllProductsFilled() }" (click)="modal.obj.step = 2">Напред</div>
            </div>
        </div>
        <div style="width:100%;height:100%;float:left;" *ngIf="modal.obj.step == 2">
            <div class="modal-ttl">Импорт на търг Бургас 2026 - Стъпка 2 / 2</div>
            <table class="products-table">
                <thead>
                    <tr>
                        <th>Гаранционен срок</th>
                        <th>Номер на договор</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>
                            <input style="width: 40%;
                            margin-left: 20px;
                            height: 30px;
                            border-radius: 5px;
                            border: 1px solid gray;" type="text" placeholder="Гаранционен срок" [(ngModel)]="modal.obj.warranty_period"  />
                            <span style="font-size: 14px;
                            margin-left: 10px;">месеца</span>
                        </td>
                        <td>
                            <input style="width: 90%;
                            margin-left: 20px;
                            height: 30px;
                            border-radius: 5px;
                            border: 1px solid gray;" type="text" placeholder="Номер на договор" [(ngModel)]="modal.obj.contract"  />
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="note" *ngIf="modal.obj.contracts.length == 0">
                <i class="icon"></i>
                <span>Няма намерени договори в файла</span>
            </div>
            <div class="button-group" *ngIf="modal.obj.contracts.length > 0">
                <div class="button" style="width:calc(33% - 23px);" (click)="PrintBurgas2026Protocols()">Генериране на протоколи</div>
                <div class="button" style="width:calc(33% - 23px);" (click)="PrintBurgas2026Warranties()">Генериране на гар.карти</div>
                <div class="button" style="width:calc(33% - 23px);" (click)="PrintBurgas2026Profilaktika()">Генериране на профилактика</div>
            </div>
            <div class="hint-group" *ngIf="modal.obj.contracts.length > 0">
                <div class="hint" style="width:calc(33% - 23px);">
                    <span *ngIf="modal.obj.generated.protocol">Вече сте генерирали протоколи, ако желаете да ги прегенерирате, натиснете бутона отново!</span>
                </div>
                <div class="hint" style="width:calc(33% - 23px);">
                    <span *ngIf="modal.obj.generated.warranty">Вече сте генерирали гаранционни карти, ако желаете да ги прегенерирате, натиснете бутона отново!</span>
                </div>
                <div class="hint" style="width:calc(33% - 23px);">
                    <span *ngIf="modal.obj.generated.profilaktika">Вече сте генерирали протокол за профилактика, ако желаете да ги прегенерирате, натиснете бутона отново!</span>
                </div>
            </div>
            <div class="btn-line" style="position:absolute;bottom:20px;" *ngIf="modal.obj.contracts.length > 0">
                <div class="btn positive" style="width:99%;" (click)="closeModal()">Приключи</div>
            </div>
        </div>
    </div>

    <div class="modal-lg" *ngIf="modal.cntx == 'contract-dimitrovgrad'">
        <div style="width:100%;height:100%;float:left;" *ngIf="modal.obj.step == 1">
            <div class="modal-ttl">Импорт на търг Димитровград - Стъпка 1 / 2</div>
            <table class="products-table">
                <thead>
                    <tr>
                        <th>Климатик</th>
                        <th>Модел от ТЕМПЕКС</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let product of modal.obj.available_products">
                        <td style="text-align:center;">{{ product.description }}</td>
                        <td>
                            <input type="text" [(ngModel)]="product.label" />
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="btn-line" style="position:absolute;bottom:20px;">
                <div class="btn back" (click)="closeModal()">Отказ</div>
                <div class="btn positive" [ngClass]="{ 'disabled':!ReturnAreAllProductsFilled() }" (click)="modal.obj.step = 2">Напред</div>
            </div>
        </div>
        <div style="width:100%;height:100%;float:left;" *ngIf="modal.obj.step == 2">
            <div class="modal-ttl">Импорт на търг Димитровград - Стъпка 2 / 2</div>
            <div class="button-group">
                <div class="button" (click)="GenerateLabels()">Генериране на етикети</div>
                <div class="button" (click)="GenerateProtocols()">Генериране на протоколи</div>
            </div>
            <div class="hint-group">
                <div class="hint">
                    <span *ngIf="labels.length != 0">Вече сте генерирали етикети, ако желаете да ги прегенерирате, натиснете бутона отново!</span>
                </div>
                <div class="hint" >
                    <span *ngIf="protocols.length != 0">Вече сте генерирали протоколи, ако желаете да ги прегенерирате, натиснете бутона отново!</span>
                </div>
            </div>
            <div class="btn-line" style="position:absolute;bottom:20px;">
                <div class="btn positive" style="width:99%;" (click)="closeModal()">Приключи</div>
            </div>
        </div>
    </div>

    <div class="modal-lg" *ngIf="modal.cntx == 'contract-dimitrovgrad2026'">
        <div style="width:100%;height:100%;float:left;" *ngIf="modal.obj.step == 1">
            <div class="modal-ttl">Импорт на търг Димитровград - Стъпка 1 / 2</div>
            <table class="products-table">
                <thead>
                    <tr>
                        <th>Климатик</th>
                        <th>Модел от ТЕМПЕКС</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let product of modal.obj.available_products">
                        <td style="text-align:center;">{{ product.description }}</td>
                        <td>
                            <input type="text" [(ngModel)]="product.label" />
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="btn-line" style="position:absolute;bottom:20px;">
                <div class="btn back" (click)="closeModal()">Отказ</div>
                <div class="btn positive" [ngClass]="{ 'disabled':!ReturnAreAllProductsFilled() }" (click)="modal.obj.step = 2">Напред</div>
            </div>
        </div>
        <div style="width:100%;height:100%;float:left;" *ngIf="modal.obj.step == 2">
            <div class="modal-ttl">Импорт на търг Димитровград - Стъпка 2 / 2</div>
            <div class="button-group">
                <div class="button" (click)="GenerateLabels()">Генериране на етикети</div>
                <div class="button" (click)="GenerateProtocolsDimitrovgrad()">Генериране на протоколи</div>
            </div>
            <div class="hint-group">
                <div class="hint">
                    <span *ngIf="labels.length != 0">Вече сте генерирали етикети, ако желаете да ги прегенерирате, натиснете бутона отново!</span>
                </div>
                <div class="hint" >
                    <span *ngIf="protocols.length != 0">Вече сте генерирали протоколи, ако желаете да ги прегенерирате, натиснете бутона отново!</span>
                </div>
            </div>
            <div class="btn-line" style="position:absolute;bottom:20px;">
                <div class="btn positive" style="width:99%;" (click)="closeModal()">Приключи</div>
            </div>
        </div>
    </div>


    <div class="modal-lg" *ngIf="modal.cntx == 'send-mass-mail'">
        <div style="width:100%;height:100%;float:left;" *ngIf="modal.obj.step == 1">
            <div class="modal-ttl">Изпращане на масов е-мейл - Стъпка 1 / 2</div>
            <div class="col-xl-12 col-lg-12 input-row">
                <span class="label">Тема на съобщение</span>
                <input type="text" placeholder="Въведете адрес на офис" [(ngModel)]="modal.obj.title" />
            </div>
            <span style="float:left;margin-left:20px;width:calc(100% - 20px);font-size:14px;">Съобщение</span>
            <angular-editor [placeholder]="'Enter text here...'" [(ngModel)]="modal.obj.layout" [config]="editorConfig"></angular-editor>
            <div class="btn-line" style="position:absolute;bottom:20px;">
                <div class="btn back" (click)="closeModal()">Отказ</div>
                <div class="btn positive" (click)="MoveEmailerToStep(2)">Напред</div>
            </div>
        </div>
        <div style="width:100%;height:100%;float:left;" *ngIf="modal.obj.step == 2">
            <div class="modal-ttl">Изпращане на масов е-мейл - Стъпка 2 / 2</div>
            <div class="email-selector">
                <div class="email-selector-label">
                    Избрани е-мейли
                    <div class="email-selector-all" style="float:right;">
                        <div class="email-selector-list-check" [ngClass]="{ 'active':modal.obj.selected_emails.length == modal.obj.accounts.length }" style="margin-top:0px;" (click)="SwitchAllEmails()"></div>
                        <span style="margin-left: 5px;font-size: 14px;">Избери всички</span>
                    </div>
                </div>
                <div class="email-selector-input">
                    <i class="icon-search"></i>
                    <input type="text" [(ngModel)]="modal.obj.account_search" />
                    <i class="icon-clear"></i>
                </div>
                <div class="email-selector-list">
                    <div *ngFor="let account of ReturnFilteredAccounts()" (click)="SelectEmail(account.email, account.username)">
                        <div class="email-selector-list-check" [ngClass]="{ 'active':ReturnIsEmailSelected(account.email) }"></div>
                        <span>{{ account.email }} ({{ account.username }})</span>
                    </div>
                </div>
            </div>
            <div class="btn-line" style="position:absolute;bottom:20px;">
                <div class="btn back" (click)="closeModal()">Отказ</div>
                <div class="btn positive" (click)="MoveEmailerToStep(3)">Напред</div>
            </div>
        </div>
    </div>


    <div class="alert" *ngIf="modal.cntx == 'remove-office'">
        <span class="alert-text">Сигурни ли сте, че искате да премахнете този офис от системата</span>
        <div class="btn-holder">
            <div class="btn positive" (click)="deleteOffice(modal.obj.uid)">Да</div>
            <div class="btn negative" (click)="closeModal()">Не</div>
        </div>
    </div>

    <div class="alert" *ngIf="modal.cntx == 'remove-warranty-text'">
        <span class="alert-text">Сигурни ли сте, че искате да премахнете тези гаранционни условия ?</span>
        <div class="btn-holder">
            <div class="btn positive" (click)="RemoveWarrantyText()">Да</div>
            <div class="btn negative" (click)="closeModal()">Не</div>
        </div>
    </div>

    <div class="alert" *ngIf="modal.cntx == 'set-default-warranty-text'">
        <span class="alert-text">Сигурни ли сте, че искате да зададете тези гаранционни условия като основни ?</span>
        <div class="btn-holder">
            <div class="btn positive" (click)="SetDefaultWarrantyText()">Да</div>
            <div class="btn negative" (click)="closeModal()">Не</div>
        </div>
    </div>


    <div class="alert" *ngIf="modal.cntx == 'loading-warranties'">
        <div class="loader">
            <div class="obj"></div><div class="obj"></div><div class="obj"></div><div class="obj"></div>
            <div class="obj"></div><div class="obj"></div><div class="obj"></div><div class="obj"></div>
        </div>
        <span class="loader-text">Зареждане на гаранционни условия...</span>
    </div>
</div>

<div id="import-html" class="import-html" style="display:none;" [innerHTML]="importHTML">
</div>

<div id="import-html1" class="import-html" style="display:none;" [innerHTML]="importHTMLFirst">
</div>

<div id="import-html2" class="import-html" style="display:none;" [innerHTML]="importHTMLSecond">
</div>

<div id="import-html-ac-list" class="import-html" style="display:none;" [innerHTML]="importHTMLAcList">
</div>


<div id="import-htmlburgas" class="import-html" style="display:none;" [innerHTML]="importHTMLBurgas">
</div>

<div id="print-label" *ngIf="print_labels">
    <div class="page-print-title">
        <span style="margin-right:10px;" (click)="PrintLabels()" class="right-btn">Разпечатване</span>
        <span style="margin-right:10px;" (click)="print_labels = false;modal.open = true" class="right-btn negative">Отказ</span>
    </div>
    <div class="label-card" *ngFor="let label of labels">
        <div class="label-name">ОПОС-{{label.num}}</div>
        <div class="label-description">
            <div>{{label.client}}</div>
            <div>{{label.phone}}</div>
            <div>{{label.city}}</div>
            <div>{{label.address}}</div>
        </div>
    </div>
</div>

<div id="print-label" *ngIf="print_contracts">
    <div class="page-print-title">
        <span style="margin-right:10px;" (click)="PrintLabels()" class="right-btn">Разпечатване</span>
        <span style="margin-right:10px;" (click)="print_contracts = false;modal.open = true" class="right-btn negative">Отказ</span>
    </div>
    <div class="contract-document" *ngFor="let contract of contracts">
        <span style="float:left;width:80%;text-align:right;margin-top:20px;font-size:12px;margin-left:10%;">{{ contract.opos }}</span>
        <div class="contract-header"></div>
        <span class="contract-underheader">Приложение № 1 </span>
        <span class="contract-title">
            <span>Приемно-предавателен протокол </span>
            <span>за доставка и монтаж на ново отоплително устройство</span>
        </span>
        <div class="contract-body">
            Днес, ...................... г., в {{ ReturnSplit(contract.address, ',', 1) }}, община {{ ReturnSplit(ReturnSplit(contract.address, ',', 1), 'гр.', 1) }}, в изпълнение на Договор №{{ ReturnSplit(contract.contract, '/', 0) }}  от {{ ReturnSplit(contract.contract, '/', 1) }}г. за доставка и монтаж на ново отоплително устройство по  проект № BG16M1OP002-5.003-0001 „Подобряване качеството на атмосферния въздух в Столична община чрез подмяна на отоплителни устройства на твърдо гориво с екологични алтернативи“ на Столична община, финансиран по Оперативна програма „Околна среда 2014-2020 г.“ с финансиране от Кохезионния фонд на Европейския съюз и националния бюджет на Република България, се подписа  настоящият приемно-предавателен протокол, с който се удостоверява, че КРАЙНИЯТ ПОЛУЧАТЕЛ по договора <br><br><span style="font-weight:bold;font-size:16px;">{{ contract.client_name }}</span> <br><br> ще получи получи безвъзмездно:
        </div>
        <div class="contract-list">
            <span>1. доставка, внасяне на мястото на монтажа, извършване на монтаж, тест, пуск и настройка на ново отоплително устройство:</span>
            <ul>
                <li *ngFor="let product of contract.products">{{ ReturnProperProductLabel(product.product) }} - {{product.product_count}}бр. {{ returnProductCountLetters(product.product_count) }}</li>
            </ul>
            <span> съобразно Техническата спецификация, неразделна част от договора с ИЗПЪЛНИТЕЛЯ </span>
            <span style="font-size: 12px;">(посочва се вид и брой на доставените и монтирани отоплителни устройства) </span>
            <Span style="margin-top:10px;">в следния недвижим имот, собственост на КРАЙНИЯ ПОЛУЧАТЕЛ: жилищна сграда, с адрес: {{ contract.address }}</Span>
        </div>
        <div class="contract-body">
            2. гаранционна карта за всяко доставено и монтирано ново отоплително устройство и радиатори (където е приложимо), считано от датата на подписване на настоящия приемно-предавателен протокол, сервизна книжка и етикет за енергийна ефективност;<br>
            3. писмени инструкции за експлоатация и поддръжка на всяко ново отоплително устройство на български език;<br>
            4. инструктаж на място при доставката и монтажа на всяко ново отоплително устройство за неговата правилна експлоатация и поддръжка.<br>
            Настоящият протокол се подписа в три еднообразни екземпляра – по един за всяка страна.
        </div>
        <div class="contract-first-sign">
            <span>ЗА ИЗПЪЛНИТЕЛЯ</span>
            <span>(име и подпис)</span>
        </div>
        <div class="contract-first-sign-hint">
            представляващ ИЗПЪЛНИТЕЛЯ, съгласно договор № {{ modal.obj.general_contract }}, сключен между Столична община и „ТЕМПЕКС“ ЕООД.  	
        </div>
        <table class="contract-second-sign">
            <tr>
                <td>ЗА ВЪЗЛОЖИТЕЛЯ: </td>
                <td>КРАЕН ПОЛУЧАТЕЛ: </td>
            </tr>
            <tr>
                <td>(име и подпис) </td>
                <td>(име и подпис) </td>
            </tr>
        </table>
        <hr style="float:left;width:80%;margin-left:10%;">
        <div class="contract-body" style="margin-top:0px;">
            <span style="float:left;width:100%;text-align:center;">www.eufunds.bg</span>
            <span style="font-size: 12px;text-align: center;float: left;width: 100%;">Документът е изготвен в изпълнение на проект № BG16M1ОP002-5.003-0001 „Подобряване качеството на атмосферния въздух в Столична община чрез подмяна на отоплителни устройства на твърдо гориво с екологични алтернативи“, финансиран по Оперативна програма „Околна среда 2014-2020 г.“, съфинансирана от Европейския съюз чрез Кохезионния фонд и от националния бюджет на Република България.</span>
        </div>
        <div style="break-after:page"></div>
    </div>
</div>

<div id="print-label" *ngIf="print_protocols_sofia">
    <div class="page-print-title">
        <span style="margin-right:10px;"class="right-btn" (click)="PrintLabels()">Разпечатване</span>
        <span style="margin-right:10px;" (click)="print_protocols_sofia = false;modal.open = true" class="right-btn negative">Отказ</span>
    </div>
    <div class="contract-document" *ngFor="let contract of protocols_sofia">
        <span style="float:left;width:80%;text-align:right;margin-top:20px;font-size:12px;margin-left:10%;">{{ contract.opos }}</span>
        <div class="contract-header"></div>
        <span class="contract-underheader">Приложение № 4 </span>
        <span class="contract-title">
            <span>Констативен протокол</span>
            <span>за извършен годишен технически преглед/извършване на текущ контрол</span>
        </span>
        <div class="contract-body">
            Днес, ...................... г., в {{ ReturnSplit(contract.address, ',', 0) }}, община Столична, в изпълнение на Договор № {{ ReturnSplit(contract.contract, '/', 0) }} от {{ ReturnSplit(contract.contract, '/', 1) }}г. за доставка и монтаж на ново отоплително устройство по проект № BG16M1OP002-5.003-0001 „Подобряване качеството на атмосферния въздух в Столична община чрез подмяна на отоплителни устройства на твърдо гориво с екологични алтернативи“ на Столична община, финансиран по Оперативна програма „Околна среда 2014-2020 г.“ с финансиране от Кохезионния фонд на Европейския съюз и националния бюджет на Република България, се подписа  настоящият констативен протокол, с който се удостоверява, че е извършен годишен технически преглед на доставеното ново отоплително устройство/извършване на текущ контрол (ненужното се зачертава)
            <span style="float:left;width:100%;margin-top:20px;font-size:16px;font-weight:bold;text-align:center">{{contract.client_name}}</span>
            <span style="float:left;width:100%;margin-top:10px;font-size:14px;font-weight:bold;text-align:center"> {{ contract.address }}</span>
        </div>
        <div class="contract-list">
            <!-- <span>1. доставка, внасяне на мястото на монтажа, извършване на монтаж, тест, пуск и настройка на ново отоплително устройство:</span> -->
            <ul>
                <li *ngFor="let product of contract.products">{{product.product}} -  ({{ ReturnProperProductLabel(product.product) }}) - {{product.product_count}}бр. {{ returnProductCountLetters(product.product_count) }}</li>
            </ul>
        </div>
        <div class="contract-body">
            1. При техническия профилактичен преглед се установи следното:<br>
            <div style="float:left;width:100%;margin-top:3px;">
                <span style="float:left;">Отоплителното устройство е налично:</span> 
                <span class="square"></span> <span style="float:left;margin-left:5px">ДА</span>  <span class="square"></span> <span style="float:left;margin-left:5px">НЕ</span>
            </div>
            <div style="float:left;width:100%;margin-top:3px;">
                <span style="float:left;">Отоплителното устройство е в цялост:</span> 
                <span class="square"></span> <span style="float:left;margin-left:5px">ДА</span>  <span class="square"></span> <span style="float:left;margin-left:5px">НЕ</span>
            </div>
            <div style="float:left;width:100%;margin-top:3px;">
                <span style="float:left;">Отоплителното устройство е в изправност:</span> 
                <span class="square"></span> <span style="float:left;margin-left:5px">ДА</span>  <span class="square"></span> <span style="float:left;margin-left:5px">НЕ</span>
            </div>
            <div style="float:left;width:100%;margin-top:3px;">
                <span style="float:left;">Отоплителното устройство е използвано съгласно инструкциите за експлоатация и поддръжка:</span>
            </div>
            <div style="float:left;width:100%;margin-top:3px;">
                <span class="square"></span><span style="float:left;margin-left:5px">ДА</span>  <span class="square"></span> <span style="float:left;margin-left:5px">НЕ</span>
            </div>
            <div style="float:left;width:100%;margin-top:3px;"><span style="float:left;">Извършвани неоторизирани ремонти:</span> <span class="square"></span> <span style="float:left;margin-left:5px">ДА</span>  <span class="square"></span> <span style="float:left;margin-left:5px">НЕ</span></div>
            Забележка: ……………………………………………………………………………………..…....<br>
            2. Извършени профилактични действия: Почистване на въздушните филтри, преглед на външен и вътрешен топлообменник, преглед на електрическите връзки и захранващ кабел, преглед на отводнителната система, проверка на изходяща температура.<br>
            3. Препоръки към крайния получател: Задължително ежемесечно почистване на въздушните филтри. Изключване на захранващия кабел, когато климатика не се използва повече от един ден. При външна температура под 0 градуса в режим на отопление е забранено да се изключва климатика. Да не се отоплява и охлажда по-голяма квадратура от препоръчаната. Задължително да се заяви и извърши годишен технически профилактичен преглед за втората и всяка следваща година. <br>
            Настоящият протокол се подписа в три еднообразни екземпляра – по един за всяка страна.
        </div>
        <div class="contract-first-sign">
            <span>ЗА ИЗПЪЛНИТЕЛЯ: Деян Чакъров ..................</span>
            <span>(име и подпис)</span>
        </div>
        <div class="contract-first-sign-hint">
            представляващ ИЗПЪЛНИТЕЛЯ, съгласно договор № {{ modal.obj.general_contract }}, сключен между Столична община и „ТЕМПЕКС“ ЕООД.  	
        </div>
        <table class="contract-second-sign">
            <tr>
                <td>ЗА ВЪЗЛОЖИТЕЛЯ: </td>
                <td>КРАЕН ПОЛУЧАТЕЛ: </td>
            </tr>
            <tr>
                <td>(име и подпис) </td>
                <td>(име и подпис) </td>
            </tr>
        </table>
        <hr style="float:left;width:80%;margin-left:10%;">
        <div class="contract-body" style="margin-top:0px;">
            <span style="float:left;width:100%;text-align:center;">www.eufunds.bg</span>
            <span style="font-size: 12px;text-align: center;float: left;width: 100%;">Документът е изготвен в изпълнение на проект № BG16M1ОP002-5.003-0001 „Подобряване качеството на атмосферния въздух в Столична община чрез подмяна на отоплителни устройства на твърдо гориво с екологични алтернативи“, финансиран по Оперативна програма „Околна среда 2014-2020 г.“, съфинансирана от Европейския съюз чрез Кохезионния фонд и от националния бюджет на Република България.</span>
        </div>
        <div style="break-after:page"></div>
    </div>
</div>

<div id="print-label" *ngIf="print_warranties">
    <div class="page-print-title">
        <span style="margin-right:10px;" (click)="PrintLabels()" class="right-btn">Разпечатване</span>
        <span style="margin-right:10px;" (click)="print_warranties = false;modal.open = true" class="right-btn negative">Отказ</span>
    </div>
    <div class="contract-document warranty" [ngStyle]="{ 'min-height':ReturnPageHeight(ReturnWarrantyProducts(warranty).length) }" style="height:auto;max-height:300vh;" *ngFor="let warranty of warranties">
        
        <div style="float:left;width:100vw;" [ngStyle]="{ 'min-height':ReturnPageMinHeight(ReturnWarrantyProducts(warranty).length) }">
            <div class="warranties-print-header">
                <!-- <div class="warranties-print-header-logo"></div> -->
                <div class="warranties-print-header-title" style="margin-left:160px;">
                    <span>ГАРАНЦИОННА КАРТА {{ warranty.opos }}</span>
                    <span>По Дог.№ {{warranty.contract}}</span>
                </div>
                <div class="warranties-print-header-warranty-time">
                    <div>Гаранционен срок</div>
                    <div>{{ modal.obj.warranty_period }} месеца</div>
                </div>
            </div>
            <table border="1" cellspacing="0" cellpadding="0" class="warranties-standard-table">
                <tbody>
                    <tr>
                        <td>Инсталационна компания<br>
                            (оторизиран гаранционен сервиз)</td>
                        <td>
                            ТЕМПЕКС ЕООД – тел.032 390102<br>
                            Дата на подписване тристранен ППП ………………
                        </td>
                    </tr>
                    <tr>
                        <td>Имена на клиент</td>
                        <td>{{ warranty.client_name }}</td>
                    </tr>
                    <tr>
                        <td>Телефон на клиента</td>
                        <td>{{ warranty.phone }}</td>
                    </tr>
                    <tr>
                        <td>Адрес на клиента</td>
                        <td>{{ warranty.address }}</td>
                    </tr>
                    <tr>
                        <td>Договор по проект ОПОС 2014-2020</td>
                        <td>№ {{modal.obj.general_contract}}</td>
                    </tr>
                </tbody>
            </table>
            <table class="warranties-product-table" border="1" cellpadding="0" cellspacing="0">
                <tr>
                    <td>I.</td>
                    <td colspan="4">Данни на Уреда</td>
                </tr>
                <tr>
                    <td>Бр.</td>
                    <td>Мощност в KW (охл./отопл.)</td>
                    <td>Модел на устройството</td>
                    <td>Сериен №<br>
                        вътрешно тяло</td>
                    <td>Сериен №<br>
                        външно тяло</td>
                </tr>
                <tr *ngFor="let product of ReturnWarrantyProducts(warranty); let i = index">
                    <td>{{ i + 1 }}</td>
                    <td>{{ product.BTU }} BTU</td>
                    <td>{{ product.product_label }}</td>
                    <td>{{ product.serial_internal }}</td>
                    <td>{{ product.serial_external }}</td>
                </tr>
            </table>
            <table class="warranties-product-table" border="1" cellpadding="0" cellspacing="0">
                <tr>
                    <td width="5%">II.</td>
                    <td colspan="2">Допълнителни особености на монтажа</td>
                </tr>
                <tr>
                    <td width="5%">1.</td>
                    <td width="55%"></td>
                    <td></td>
                </tr>
            </table>
            <table class="warranties-product-table" border="1" cellpadding="0" cellspacing="0">
                <tr>
                    <td width="5%">III.</td>
                    <td style="width:35%">Технически прегледи</td>
                    <td style="width:20%">Дата</td>
                    <td>Сервизен техник и подпис</td>
                </tr>
                <tr>
                    <td width="5%">1.</td>
                    <td style="width:35%">Първи технически преглед, след първата година.</td>
                    <td style="width:20%"></td>
                    <td></td>
                </tr>
                <tr>
                    <td width="5%">2.</td>
                    <td style="width:35%">Втори технически преглед, след втората година.</td>
                    <td style="width:20%"></td>
                    <td></td>
                </tr>
                <tr>
                    <td width="5%">3.</td>
                    <td style="width:35%">Трети технически преглед, след третата година.</td>
                    <td style="width:20%"></td>
                    <td></td>
                </tr>
                <tr>
                    <td width="5%">4.</td>
                    <td style="width:35%">Четвърти техн.преглед, след четвъртата година.</td>
                    <td style="width:20%"></td>
                    <td></td>
                </tr>
            </table>
            <div class="warranties-confirm">
                <span>Съгласен съм с извършените СМР: </span>
                <div class="warranties-field-check">
                    <div class="check"></div>
                    <span>ДА</span>
                </div>
                <div class="warranties-field-check">
                    <div class="check"></div>
                    <span>НЕ</span>
                </div>
            </div>
            <table class="warranties-notes">
                <tr>
                    <td>Забележка:...................................................................................................</td>
                    <td>Подпис клиент......................</td>
                </tr>
                <tr>
                    <td>Контакти: Пловдив,бул.Кукленско шосе №52; тел.032390102</td>
                    <td>Подпис монтажник...................</td>
                </tr>
            </table>
        </div>
        <p style="page-break-after:always;height:1px;width:100%;" *ngIf="ReturnWarrantyProducts(warranty).length > 4"></p>
        <div class="warranties-rights">
        <span>IV. ГАРАНЦИОННИ УСЛОВИЯ</span>
1. Гаранционният срок на изделието е {{modal.obj.warranty_period}} месеца и започва да тече от подписването на тристранен приемо-предавателен протокол за доставка, монтаж и въвеждане в експлоатация, подписан от представител на Възложителя, от Изпълнителя и от крайния получател (или негов пълномощник) в три екземпляра.
<br>2. Гаранцията е валидна само срещу предоставяне на гаранционна карта от клиента. Внимание: Повредена, неправилно или непълно попълнена гаранционна карта е невалидна! На загубена или увредена гаранционна карта дубликат не се издава.
<br>3. В рамките на гаранционния срок изпълнителят се задължава да отстранява появили се скрити недостатъци и/или такива, настъпили вследствие на извършения монтаж, ако недостатъкът не може да бъде отстранен/отремонтиран, устройството се заменя с ново.
<br>4. В случай на възникнала необходимост от ремонт на устройствата, разходите за демонтаж, монтаж, зареждане с хладилен агент, транспорт и други съпътстващи са за сметка на изпълнителя. Гаранционният срок се удължава със срока за отстраняване на неизправностите.
<br>5. Гаранционното обслужване е безплатно за неизправностите, вследствие на фабричен дефект.
<br>6. Годишни технически прегледи на новото отоплително устройство между два отоплителни сезона в гаранционния срок се налага поради евентуалното запушване, както на вътрешния така и на външния топлообменник от прах и мръсотия което в последствие би довело до неправилна работа или дефект на климатичната система и би било основание за отказ от гаранционно обслужване. При годишната профилактика се извършва пълно обслужване и замерване параметрите на климатика при нормална работа и при отклонение те се коригират. При липса на такъв преглед в края на всяка година от подписването на тристранен приемо-предавателен протокол за доставка, монтаж и въвеждане в експлоатация, не може да се установи при какви условия е работил климатикът, което би било основание за отказ от гаранционно обслужване при повреда. Годишната профилактика за първата година е безплатна, като профилактиката за втората и всяка следваща година не е предмет на безплатното гаранционно обслужване и се заплаща от клиента по утвърдена тарифа. Профилактиката се заявява от клиента по телефон на изпълнителя до 10 /десет/ дни преди изтичане на годината от датата на подписване на тристранен приемо-предавателен протокол за доставка, монтаж и въвеждане в експлоатация.
<br>7. Гаранцията се отнася за повреди, възникнали в процеса на правилната експлоатация /съгласно Инструкцията за употреба на съответния модел/ през гаранционния период. Всички такива повреди се отстраняват безплатно.
БЕЗПЛАТЕН ГАРАНЦИОНЕН СЕРВИЗ СЕ ОТКАЗВА В СЛЕДНИТЕ СЛУЧАИ:
<br>- подправени, непълно или неточно попълнени данни в гаранционната карта на оборудването;
<br>- не са спазени условията за съхранение и експлоатация, посочени в упътването на продукта;
<br>- когато е правен опит за отстраняване на повредата от неупълномощени лица;
<br>- не е заявена и извършена годишна профилактика за втората и всяка следваща година;
<br>- при сътресения, удари и претоварвания вследствие на небрежно отношение;
<br>- когато повредата е причинена от природно бедствие, токов удар, неизправност в захранващата мрежа или други форсмажорни обстоятелства.
НА ГАРАНЦИЯ НЕ ПОДЛЕЖАТ:
<br>-дистанционното управление; - пластмасовите части,въздушни филтри, антибактериални филтри; -пластмасовите части; - почистването на инсталацията, филтрите на вътрешното тяло, отпушване на кондензен маркуч.
Внимание: Преди да се отнесете към сервиза проверете в Инструкцията дали не е описан Вашия проблем.
Клиентът е длъжен да осигури свободен достъп на сервизните специалисти до климатизатора.
Когато при диагностика, включително и на гаранционен климатизатор се установи, че същия е изправен и техническите му параметри са в нормите,  зададени от производителя, клиентът е длъжен да заплати направените разходи от сервизните специалисти по утвърден ценоразпис.
ОСЪЩЕСТВЯВАНЕ НА ГАРАНЦИЯТА:
<br>- В случай на повреда на оборудването в неговия гаранционен срок, представител на Възложителя или крайния получател на оборудването отправя съобщение до изпълнителя. Съобщението може да бъде изпратено по факс, електронна поща или обикновена поща. Изпълнител е длъжен да реагира в рамките на работния ден или не повече от 8 часа след подаване на съобщението, след което да отстрани повредата в рамките на 72 часа от подадена заявка.
<br>- Повредата на климатизатора в рамките на гаранционния срок не е основание за подмяна с нов. Не се ангажираме с допустим максимален брой ремонти, които да налагат замяната на определена стока с нова;- Посещение на специалист по заявка на клиента и липса на гаранционен дефект или неспазени условия се заплаща от клиента;
<br>- Вносителят и изпълнителят не са отговорни за пропуснати ползи и последвали загуби, в следствие на дефектна стока и престоя й в сервиза, както и да осигуряват оборотно друга стока. Не се обвързваме с допустим максимален брой ремонти, което да налага замяна на климатичната инсталация с нова.
ПРАВА НА ПОТРЕБИТЕЛЯТ ПО ЗАКОНА ЗА ЗАЩИТА НА ПОТРЕБИТЕЛИТЕ
Съгласно чл. 112 от ЗЗП, потребителят има следните права:
При несъответствие на продукта със сделката за продажба, потребителят има право да предяви рекламация, като поиска от Продавача да приведе стоката в съответствие със сделката за продажба. В този случай Потребителят може да избира между извършване на ремонт на стоката или размяната й с нова, освен ако това е невъзможно или избраният от него начин на обезщетение е непропорционален в сравнение с другия. Смята се, че даден начин за обезщетяване на Потребителя е непропорционален, ако неговото използване налага разходи на Продавача, които в сравнение с другия начин на обезщетяване са неразумни, като се вземат предвид: стойността на потребителската стока ако няма липса на несъответствие; значимостта на несъответствието, възможността да се предложи на Потребителя друг начин на обезщетяване, който не е свързан със значителни неудобства за него.
Съгласно чл. 113 от ЗЗП, потребителят има следните права:
<br>- Когато продуктът не съответства на сделката за продажба, Продавачът е длъжен да я приведе в съответствие със сделката за продажба;
<br>- Привеждането на продукта в съответствие със сделката за продажба трябва да се извърши в рамките на един месец, считано от предявяването на рекламация от потребителя;
<br>- След изтичането на срока по ал. 2 Потребителят има право да развали сделката и да му бъде възстановена заплатената сума или да иска намаляване на цената на потребителската стока съгласно чл. 114 от ЗЗП;
<br>- Привеждането на продукта в съответствие със сделката за продажба е безплатно за потребителя. Той не дължи разходи за екстрадирането на потребителската стока или за материали и труд, свързани с ремонта й и не трябва да понася значителни неудобства;- Потребителят може да иска и обезщетение за претърпените в последствие на несъответствието вреди. 
Съгласно чл. 114 от ЗЗП, потребителят има следните права:
<br>- При несъответствие на продукта с на продажба и когато Потребителят не е удовлетворен от решаването на рекламацията по чл. 113 от ЗЗП, Потребителят има право на избор между една от следните възможности: разваляне на сделката и възстановяване на заплатената от него сума; намаляване на цента;
<br>- Потребителят не може да претендира за възстановяване на заплатената сума или за намаляване цената на продукта, когато Търговецът се съгласи да бъде извършена замяна на продукта с нов или да се поправи продукта в рамките на един месец от предявяване на рекламацията от Потребителя;
<br>- Упражняването на правото на Потребителя по ал. 1 не е обвързано с никакъв друг срок за предявяване на иск, различен от срока по ал. 1.
Съгласно чл. 115 от ЗЗП, потребителят има следните права:
<br>- Потребителят може да упражни правото си по този раздел в срок от две години, считано от доставянето на продукта;
<br>- Срокът по ал. 1 спира да тече през времето, необходимо за поправката или замяната на продукта или за постигане на споразумение между Продавача и Потребителя за решаване на спора;
<br>- Упражняването на правото на Потребителя по ал. 1 не е обвързано с никакъв друг срок за предявяване на иск, различен от срока по ал. 1.			                                            <br><br><br><br><br>Съгласен съм и приемам условията: ............................(Подпис клиент) 
        </div>
        <p style="page-break-after:always;height:1px;width:100%;" *ngIf="ReturnWarrantyProducts(warranty).length > 4"></p>
    </div>
</div>

<div id="print-label" *ngIf="print_protocols">
    <div class="page-print-title">
        <span style="margin-right:10px;" (click)="PrintLabels()" class="right-btn">Разпечатване</span>
        <span style="margin-right:10px;" (click)="print_protocols = false;modal.open = true" class="right-btn negative">Отказ</span>
    </div>
    <div class="contract-document" *ngFor="let protocol of protocols">
        <div class="protocol-header">
            <div class="protocol-header-logo-1"></div>
            <div class="protocol-header-logo-2"></div>
            <div class="protocol-header-logo-3"></div>
        </div>
        <span class="contract-underheader">Приложение № 1 </span>
        <span class="contract-title">
            <span>Приемно-предавателен протокол </span>
            <span>за доставка и монтаж на ново отоплително устройство</span>
        </span>
        <div class="contract-body">
            Днес, {{ReturnSplitDate(protocol.date)}}., в гр. Димитровград, община Димитровград, в изпълнение на Договор № {{protocol.num}} за доставка и монтаж на ново отоплително устройство по  проект „Подобряване качеството на атмосферния въздух в община Димитровград чрез подмяна на отоплителни устройства на твърдо гориво с алтернативни форми на отопление“,  Договор № BG16M1OP002-5.003-0005-C03 на община Димитровград, финансиран по Оперативна програма „Околна среда 2014-2020 г.“ с финансиране от Кохезионния фонд на Европейския съюз и националния бюджет на Република България, се подписа настоящият приемо-предавателен протокол, с който се удостоверява, че КРАЙНИЯТ ПОЛУЧАТЕЛ по договора <br><br><span style="font-weight:bold;font-size:16px;">{{ protocol.client }}</span> <br><br> ще получи получи безвъзмездно:
        </div>
        <div class="contract-list">
            <span>1. Доставка и монтаж на ново отоплително устройство:</span>
            <ul>
                <li *ngFor="let product of protocol.products">{{ ReturnProperProductLabelProtocols(product) }} - {{product.count}}бр. {{ returnProductCountLetters(product.count) }}</li>
            </ul>
            <Span style="margin-top:10px;">в следния недвижим имот, собственост на КРАЙНИЯ ПОЛУЧАТЕЛ: жилищна сграда, с адрес: <br><br><span style="font-weight:bold;font-size:16px;">гр.{{protocol.city}}, {{ protocol.address }}</span><br><br></Span>
        </div>
        <div class="contract-body">
            2. гаранционна карта за гаранция от 24 месеца и гаранционен сервиз на отоплителното устройство по т.1, считано от датата на подписване на настоящия приемо-предавателен протокол;<br>
            3. писмени инструкции за експлоатация и поддръжка на новото отоплително устройство на български език;.<br>
            4. инструктаж на място при доставката и монтажа на новото отоплително устройство за неговата правилна експлоатация и поддръжка.<br>
            Настоящият протокол се подписа в три еднообразни екземпляра – по един за всяка страна.
        </div>
        <div class="contract-first-sign">
            <span>ЗА ИЗПЪЛНИТЕЛЯ</span>
            <span>(име и подпис)</span>
        </div>
        <table class="contract-second-sign">
            <tr>
                <td>ЗА ВЪЗЛОЖИТЕЛЯ: </td>
                <td>КРАЕН ПОЛУЧАТЕЛ: </td>
            </tr>
            <tr>
                <td>(име и подпис) </td>
                <td>(име и подпис) </td>
            </tr>
        </table>
        <!-- <hr style="float:left;width:80%;margin-left:10%;">
        <div class="contract-body" style="margin-top:0px;">
            <span style="float:left;width:100%;text-align:center;">www.eufunds.bg</span>
            <span style="font-size: 12px;text-align: center;float: left;width: 100%;">Документът е изготвен в изпълнение на проект № BG16M1ОP002-5.003-0001 „Подобряване качеството на атмосферния въздух в Столична община чрез подмяна на отоплителни устройства на твърдо гориво с екологични алтернативи“, финансиран по Оперативна програма „Околна среда 2014-2020 г.“, съфинансирана от Европейския съюз чрез Кохезионния фонд и от националния бюджет на Република България.</span>
        </div> -->
        <div style="break-after:page"></div>
    </div>
</div>

<div id="print-label" *ngIf="print_protocols_dimitrovgrad2026">
    <div class="page-print-title">
        <span style="margin-right:10px;" (click)="PrintLabels()" class="right-btn">Разпечатване</span>
        <span style="margin-right:10px;" (click)="print_protocols_dimitrovgrad2026 = false;modal.open = true" class="right-btn negative">Отказ</span>
    </div>
    <div class="contract-document" *ngFor="let protocol of protocols">
        <div class="protocol-header dimitrovgrad2026">
            <div class="protocol-header-logo-1"></div>
            <div class="protocol-header-logo-2"></div>
            <div class="protocol-header-logo-3"></div>
        </div>
        <span class="contract-underheader">Приложение № 1 </span>
        <span class="contract-title">
            <span>Приемо-предавателен протокол </span>
            <span>за доставка и монтаж на ново отоплително устройство</span>
        </span>
        <div class="contract-body">
            Днес, ...................... г., в гр. Димитровград, община Димитровград, в изпълнение на Договор № {{protocol.num}} за доставка и монтаж на ново отоплително устройство по  проект „За по-чист въздух в община Димитровград“, на община Димитровград по Програма „Околна среда“ 2021-2027 г. с финансиране от Европейския фонд за регионално развитие на Европейския съюз и националния бюджет на Република България, се подписа настоящият приемо-предавателен протокол, с който се удостоверява, че КРАЙНИЯТ ПОЛУЧАТЕЛ по договора <br><br><span style="font-weight:bold;font-size:16px;">{{ protocol.client }}</span> <br><br> получи безвъзмездно:
        </div>
        <div class="contract-list">
            <span>1. доставка, внасяне на мястото на монтажа, монтаж, тест, пуск и настройка на ново отоплително устройство:</span>
            <ul>
                <li *ngFor="let product of protocol.products">{{ ReturnProperProductLabelProtocols(product) }} - {{product.count}}бр. {{ returnProductCountLetters(product.count) }}</li>
            </ul>
            <Span style="margin-top:10px;">в следния жилищен обект, собственост на КРАЙНИЯ ПОЛУЧАТЕЛ: жилищна сграда, с адрес: <br><br><span style="font-weight:bold;font-size:16px;">{{protocol.city}}<i *ngIf="protocol.street != '0'">, {{protocol.street}}</i> <i *ngIf="protocol.street_num != '0'"> №{{ protocol.street_num }}</i><i *ngIf="protocol.building_num != '0'">, бл.{{ protocol.building_num}}</i><i *ngIf="protocol.enterence_num != '0'">, вх.{{protocol.enterence_num}}</i><i *ngIf="protocol.floor != '0'">, ет.{{protocol.floor}}</i><i *ngIf="protocol.apartment != '0'">, ап.{{ protocol.apartment }}</i></span><br><br></Span>
        </div>
        <div class="contract-body" style="margin-bottom:40px;">
            2. гаранционна карта за всяко монтирано отоплително устройство и радиатори (където е приложимо), считано от датата на подписване на настоящия приемо-предавателен протокол;<br>
            3. писмени инструкции за експлоатация и поддръжка на новото отоплително устройство на български език;<br>
            4. инструктаж на място при доставката и монтажа на новото отоплително устройство за неговата правилна експлоатация и поддръжка.<br>
            Настоящият протокол се подписа в три еднообразни екземпляра – един за всяка Страна.<br>
        </div>
        <div class="contract-first-sign" style="margin-bottom:40px;">
            <span>ЗА ИЗПЪЛНИТЕЛЯ: Кр.Кирилова</span>
            <span>(име и подпис)</span>
        </div>
        <table class="contract-second-sign">
            <tr>
                <td>ЗА ВЪЗЛОЖИТЕЛЯ: </td>
                <td>КРАЕН ПОЛУЧАТЕЛ: </td>
            </tr>
            <tr>
                <td>(име и подпис) </td>
                <td>(име и подпис) </td>
            </tr>
        </table>
        <hr style="float:left;width:80%;margin-left:10%;">
        <div class="contract-body" style="margin-top:0px;">
            <span style="float:left;width:100%;text-align:center;">www.eufunds.bg</span>
            <span style="font-size: 12px;text-align: center;float: left;width: 100%;">
            Този документ е изготвен в изпълнение на  проект № BG16FFPR002-5.001-0010 „За по-чист въздух в община Димитровград“ по Програма „Околна среда“ 2021-2027 г., финансиран от Европейския фонд за регионално развитие на Европейския съюз и от националния бюджет на Република България</span>
        </div>
        <div style="break-after:page"></div>
    </div>
</div>

<div id="print-label" *ngIf="modal.cntx == 'importing-contracts-burgas' && modal.obj.print_burgas_protocols">
    <div class="page-print-title">
        <span style="margin-right:10px;" (click)="PrintLabels()" class="right-btn">Разпечатване</span>
        <span style="margin-right:10px;" (click)="modal.obj.print_burgas_protocols = false;modal.open = true" class="right-btn negative">Отказ</span>
    </div>
    <div class="contract-document" *ngFor="let contract of modal.obj.contracts">
        <div class="protocol-header">
            <div class="protocol-header-logo-1"></div>
            <div class="protocol-header-logo-2 burgas" style="width: 100px;margin-left:calc(50% - 140px)"></div>
            <div class="protocol-header-logo-3"></div>
        </div>
        <span class="contract-underheader">Приложение № 1 </span>
        <span class="contract-title">
            <span>Приемно-предавателен протокол </span>
            <span>за доставка и монтаж на ново отоплително устройство</span>
        </span>
        <div class="contract-body">
            Днес, ....................... г., в гр. Бургас, община Бургас, в изпълнение на Договор № {{modal.obj.contract}} по рамково споразумение № 93-ОП22-22/3/17.08.2023 г.  за доставка и монтаж на ново отоплително устройство по проект BG16M1OP002-5.003-0003 „Намаляване на замърсяването на атмосферния въздух с фини прахови частици в кв. Долно Езерово, гр. Бургас“, финансиран по Оперативна програма „Околна среда“ 2014-2020 г., Приоритетна ос „Подобряване качеството на атмосферния въздух“, процедура BG16M1OP002-5.003 „Мерки за подобряване качеството на атмосферния въздух“, се подписа настоящия приемо-предавателен протокол, с който се удостоверява, че ИЗПЪЛНИТЕЛЯТ – ТЕМПЕКС ЕООД предава, а КРАЙНИЯТ ПОЛУЧАТЕЛ, съгласно сключен договор и заявление №: {{ contract.contract }} <br><br><span style="font-weight:bold;font-size:16px;">{{ contract.name }}</span> <br><br> ще получи получи безвъзмездно:
        </div>
        <div class="contract-list">
            <span>1. Доставка и монтаж на ново отоплително устройство:</span>
            <ul>
                <li *ngFor="let product of contract.products; let i = index" [ngClass]="{ 'hidden':product == 0 }">{{ ReturnProductDescriptionById(i) }} - (марка: TREO, модел: {{ ReturnProductLabelById(i) }}) - {{product}} {{ returnProductCountLetters(product) }}</li>
            </ul>
            <Span style="margin-top:10px;">в следния недвижим имот, собственост на КРАЙНИЯ ПОЛУЧАТЕЛ: жилищна сграда, с адрес: <br><br><span style="font-weight:bold;font-size:16px;">{{ contract.address }}</span><br><br></Span>
        </div>
        <div class="contract-body">
            2. гаранционна карта за двегодишна гаранция и гаранционен сервиз на отоплителното устройство по т. 1, считано от датата на подписване на настоящия приемо-предавателен протокол;<br>
            3. писмени инструкции за експлоатация и поддръжка на новото отоплително устройство на български език;<br>
            4. инструктаж на място при доставката и монтажа на новото отоплително устройство за неговата правилна експлоатация и поддръжка.<br>
            Настоящият протокол се подписа в три еднообразни екземпляра – един за КРАЙНИЯ ПОЛУЧАТЕЛ, един за Изпълнителя и един за Възложителя.
        </div>
        <table class="contract-second-sign">
            <tr>
                <td>ИЗПЪЛНИТЕЛ (за предал): </td>
                <td>КРАЕН ПОЛУЧАТЕЛ (за приел): </td>
            </tr>
            <tr>
                <td>Георги Топалов </td>
                <td>(име и подпис) </td>
            </tr>
        </table>
        <hr style="float:left;width:80%;margin-left:10%;">
        <div class="contract-body" style="margin-top:0px;">
            <span style="font-size: 12px;text-align: center;float: left;width: 100%;">Този документ е изготвен в рамките на проект BG16M1OP002-5.003-0003 „Намаляване на замърсяването на атмосферния въздух с фини прахови частици в кв. Долно Езерово, гр. Бургас“,АДБФП №  BG16M1OP002-5.003-0003-C02, финансиран по Оперативна програма „Околна среда“ 2014-2020 г., Приоритетна ос „Подобряване качеството на атмосферния въздух“, процедура BG16M1OP002-5.003 „Мерки за подобряване качеството на атмосферния въздух“</span>
        </div>
        <div style="break-after:page"></div>
    </div>
</div>

<div id="print-label"  *ngIf="modal.cntx == 'importing-contracts-burgas' && modal.obj.print_burgas_warranties">
    <div class="page-print-title">
        <span style="margin-right:10px;" (click)="PrintLabels()" class="right-btn">Разпечатване</span>
        <span style="margin-right:10px;" (click)="modal.obj.print_burgas_warranties = false;modal.open = true" class="right-btn negative">Отказ</span>
    </div>
    <div class="contract-document warranty" *ngFor="let contract of modal.obj.contracts">
        <div style="float:left;width:100vw;height:100vh;">
            <div class="warranties-print-header">
                <!-- <div class="warranties-print-header-logo"></div> -->
                <div class="warranties-print-header-title" style="margin-left:160px;">
                    <span>ГАРАНЦИОННА КАРТА {{ ReturnOnlyContract(contract.contract) }}</span>
                    <span>По Дог.№ {{contract.contract}}</span>
                </div>
                <div class="warranties-print-header-warranty-time">
                    <div>Гаранционен срок</div>
                    <div>{{ modal.obj.warranty_period }} месеца</div>
                </div>
            </div>
            <table border="1" cellspacing="0" cellpadding="0" class="warranties-standard-table">
                <tbody>
                    <tr>
                        <td>Инсталационна компания<br>
                            (оторизиран гаранционен сервиз)</td>
                        <td>
                            ТЕМПЕКС ЕООД – тел.032 390102<br>
                            Дата на подписване тристранен ППП ………………
                        </td>
                    </tr>
                    <tr>
                        <td>Имена на клиент</td>
                        <td>{{ contract.name }}</td>
                    </tr>
                    <tr>
                        <td>Телефон на клиента</td>
                        <td>{{ contract.phone }}</td>
                    </tr>
                    <tr>
                        <td>Адрес на клиента</td>
                        <td>{{ contract.address }}</td>
                    </tr>
                    <tr>
                        <td>Договор по проект ОПОС 2014-2020</td>
                        <td>№ {{ modal.obj.contract }}</td>
                    </tr>
                </tbody>
            </table>
            <table class="warranties-product-table" border="1" cellpadding="0" cellspacing="0">
                <tr>
                    <td>I.</td>
                    <td colspan="4">Данни на Уреда</td>
                </tr>
                <tr>
                    <td width="5%">Бр.</td>
                    <td width="40%">Мощност в KW (охл./отопл.)</td>
                    <td>Сериен №<br>
                        вътрешно тяло</td>
                    <td>Сериен №<br>
                        външно тяло</td>
                </tr>
                <tr *ngFor="let product of contract.products; let i = index" [ngClass]="{ 'hidden':product == 0 }">
                    <td width="5%">{{ product }}</td>
                    <td width="40%">{{ ReturnProductDescriptionById(i) }} - (Марка - TREO, Модел - {{ ReturnProductLabelById(i) }})</td>
                    <td></td>
                    <td></td>
                </tr>
            </table>
            <table class="warranties-product-table" border="1" cellpadding="0" cellspacing="0">
                <tr>
                    <td width="5%">II.</td>
                    <td colspan="2">Допълнителни особености на монтажа</td>
                </tr>
                <tr>
                    <td width="5%">1.</td>
                    <td width="55%"></td>
                    <td></td>
                </tr>
            </table>
            <table class="warranties-product-table" border="1" cellpadding="0" cellspacing="0">
                <tr>
                    <td width="5%">III.</td>
                    <td style="width:35%">Технически прегледи</td>
                    <td style="width:20%">Дата</td>
                    <td>Сервизен техник и подпис</td>
                </tr>
                <tr>
                    <td width="5%">1.</td>
                    <td style="width:35%">Първи технически преглед, след първата година.</td>
                    <td style="width:20%"></td>
                    <td></td>
                </tr>
                <!-- <tr>
                    <td width="5%">2.</td>
                    <td style="width:35%">Втори технически преглед, след втората година.</td>
                    <td style="width:20%"></td>
                    <td></td>
                </tr>
                <tr>
                    <td width="5%">3.</td>
                    <td style="width:35%">Трети технически преглед, след третата година.</td>
                    <td style="width:20%"></td>
                    <td></td>
                </tr>
                <tr>
                    <td width="5%">4.</td>
                    <td style="width:35%">Четвърти техн.преглед, след четвъртата година.</td>
                    <td style="width:20%"></td>
                    <td></td>
                </tr> -->
            </table>
            <div class="warranties-confirm">
                <span>Съгласен съм с извършените СМР: </span>
                <div class="warranties-field-check">
                    <div class="check"></div>
                    <span>ДА</span>
                </div>
                <div class="warranties-field-check">
                    <div class="check"></div>
                    <span>НЕ</span>
                </div>
            </div>
            <table class="warranties-notes">
                <tr>
                    <td>Забележка:...................................................................................................</td>
                    <td>Подпис клиент......................</td>
                </tr>
                <tr>
                    <td>Контакти: Пловдив,бул.Кукленско шосе №52; тел.032390102</td>
                    <td>Подпис монтажник...................</td>
                </tr>
            </table>
        </div>
        <div class="warranties-rights">
        <span>IV. ГАРАНЦИОННИ УСЛОВИЯ</span>
1. Гаранционният срок на изделието е {{modal.obj.warranty_period}} месеца и започва да тече от подписването на тристранен приемо-предавателен протокол за доставка, монтаж и въвеждане в експлоатация, подписан от представител на Възложителя, от Изпълнителя и от крайния получател (или негов пълномощник) в три екземпляра.
<br>2. Гаранцията е валидна само срещу предоставяне на гаранционна карта от клиента. Внимание: Повредена, неправилно или непълно попълнена гаранционна карта е невалидна! На загубена или увредена гаранционна карта дубликат не се издава.
<br>3. В рамките на гаранционния срок изпълнителят се задължава да отстранява появили се скрити недостатъци и/или такива, настъпили вследствие на извършения монтаж, ако недостатъкът не може да бъде отстранен/отремонтиран, устройството се заменя с ново.
<br>4. В случай на възникнала необходимост от ремонт на устройствата, разходите за демонтаж, монтаж, зареждане с хладилен агент, транспорт и други съпътстващи са за сметка на изпълнителя. Гаранционният срок се удължава със срока за отстраняване на неизправностите.
<br>5. Гаранционното обслужване е безплатно за неизправностите, вследствие на фабричен дефект.
<br>6. Годишни технически прегледи на новото отоплително устройство между два отоплителни сезона в гаранционния срок се налага поради евентуалното запушване, както на вътрешния така и на външния топлообменник от прах и мръсотия което в последствие би довело до неправилна работа или дефект на климатичната система и би било основание за отказ от гаранционно обслужване. При годишната профилактика се извършва пълно обслужване и замерване параметрите на климатика при нормална работа и при отклонение те се коригират. При липса на такъв преглед в края на всяка година от подписването на тристранен приемо-предавателен протокол за доставка, монтаж и въвеждане в експлоатация, не може да се установи при какви условия е работил климатикът, което би било основание за отказ от гаранционно обслужване при повреда. Годишната профилактика за първата година е безплатна, като профилактиката за втората и всяка следваща година не е предмет на безплатното гаранционно обслужване и се заплаща от клиента по утвърдена тарифа. Профилактиката се заявява от клиента по телефон на изпълнителя до 10 /десет/ дни преди изтичане на годината от датата на подписване на тристранен приемо-предавателен протокол за доставка, монтаж и въвеждане в експлоатация.
<br>7. Гаранцията се отнася за повреди, възникнали в процеса на правилната експлоатация /съгласно Инструкцията за употреба на съответния модел/ през гаранционния период. Всички такива повреди се отстраняват безплатно.
БЕЗПЛАТЕН ГАРАНЦИОНЕН СЕРВИЗ СЕ ОТКАЗВА В СЛЕДНИТЕ СЛУЧАИ:
<br>- подправени, непълно или неточно попълнени данни в гаранционната карта на оборудването;
<br>- не са спазени условията за съхранение и експлоатация, посочени в упътването на продукта;
<br>- когато е правен опит за отстраняване на повредата от неупълномощени лица;
<br>- не е заявена и извършена годишна профилактика за втората и всяка следваща година;
<br>- при сътресения, удари и претоварвания вследствие на небрежно отношение;
<br>- когато повредата е причинена от природно бедствие, токов удар, неизправност в захранващата мрежа или други форсмажорни обстоятелства.
НА ГАРАНЦИЯ НЕ ПОДЛЕЖАТ:
<br>-дистанционното управление; - пластмасовите части,въздушни филтри, антибактериални филтри; -пластмасовите части; - почистването на инсталацията, филтрите на вътрешното тяло, отпушване на кондензен маркуч.
Внимание: Преди да се отнесете към сервиза проверете в Инструкцията дали не е описан Вашия проблем.
Клиентът е длъжен да осигури свободен достъп на сервизните специалисти до климатизатора.
Когато при диагностика, включително и на гаранционен климатизатор се установи, че същия е изправен и техническите му параметри са в нормите,  зададени от производителя, клиентът е длъжен да заплати направените разходи от сервизните специалисти по утвърден ценоразпис.
ОСЪЩЕСТВЯВАНЕ НА ГАРАНЦИЯТА:
<br>- В случай на повреда на оборудването в неговия гаранционен срок, представител на Възложителя или крайния получател на оборудването отправя съобщение до изпълнителя. Съобщението може да бъде изпратено по факс, електронна поща или обикновена поща. Изпълнител е длъжен да реагира в рамките на работния ден или не повече от 8 часа след подаване на съобщението, след което да отстрани повредата в рамките на 72 часа от подадена заявка.
<br>- Повредата на климатизатора в рамките на гаранционния срок не е основание за подмяна с нов. Не се ангажираме с допустим максимален брой ремонти, които да налагат замяната на определена стока с нова;- Посещение на специалист по заявка на клиента и липса на гаранционен дефект или неспазени условия се заплаща от клиента;
<br>- Вносителят и изпълнителят не са отговорни за пропуснати ползи и последвали загуби, в следствие на дефектна стока и престоя й в сервиза, както и да осигуряват оборотно друга стока. Не се обвързваме с допустим максимален брой ремонти, което да налага замяна на климатичната инсталация с нова.
ПРАВА НА ПОТРЕБИТЕЛЯТ ПО ЗАКОНА ЗА ЗАЩИТА НА ПОТРЕБИТЕЛИТЕ
Съгласно чл. 112 от ЗЗП, потребителят има следните права:
При несъответствие на продукта със сделката за продажба, потребителят има право да предяви рекламация, като поиска от Продавача да приведе стоката в съответствие със сделката за продажба. В този случай Потребителят може да избира между извършване на ремонт на стоката или размяната й с нова, освен ако това е невъзможно или избраният от него начин на обезщетение е непропорционален в сравнение с другия. Смята се, че даден начин за обезщетяване на Потребителя е непропорционален, ако неговото използване налага разходи на Продавача, които в сравнение с другия начин на обезщетяване са неразумни, като се вземат предвид: стойността на потребителската стока ако няма липса на несъответствие; значимостта на несъответствието, възможността да се предложи на Потребителя друг начин на обезщетяване, който не е свързан със значителни неудобства за него.
Съгласно чл. 113 от ЗЗП, потребителят има следните права:
<br>- Когато продуктът не съответства на сделката за продажба, Продавачът е длъжен да я приведе в съответствие със сделката за продажба;
<br>- Привеждането на продукта в съответствие със сделката за продажба трябва да се извърши в рамките на един месец, считано от предявяването на рекламация от потребителя;
<br>- След изтичането на срока по ал. 2 Потребителят има право да развали сделката и да му бъде възстановена заплатената сума или да иска намаляване на цената на потребителската стока съгласно чл. 114 от ЗЗП;
<br>- Привеждането на продукта в съответствие със сделката за продажба е безплатно за потребителя. Той не дължи разходи за екстрадирането на потребителската стока или за материали и труд, свързани с ремонта й и не трябва да понася значителни неудобства;- Потребителят може да иска и обезщетение за претърпените в последствие на несъответствието вреди. 
Съгласно чл. 114 от ЗЗП, потребителят има следните права:
<br>- При несъответствие на продукта с на продажба и когато Потребителят не е удовлетворен от решаването на рекламацията по чл. 113 от ЗЗП, Потребителят има право на избор между една от следните възможности: разваляне на сделката и възстановяване на заплатената от него сума; намаляване на цента;
<br>- Потребителят не може да претендира за възстановяване на заплатената сума или за намаляване цената на продукта, когато Търговецът се съгласи да бъде извършена замяна на продукта с нов или да се поправи продукта в рамките на един месец от предявяване на рекламацията от Потребителя;
<br>- Упражняването на правото на Потребителя по ал. 1 не е обвързано с никакъв друг срок за предявяване на иск, различен от срока по ал. 1.
Съгласно чл. 115 от ЗЗП, потребителят има следните права:
<br>- Потребителят може да упражни правото си по този раздел в срок от две години, считано от доставянето на продукта;
<br>- Срокът по ал. 1 спира да тече през времето, необходимо за поправката или замяната на продукта или за постигане на споразумение между Продавача и Потребителя за решаване на спора;
<br>- Упражняването на правото на Потребителя по ал. 1 не е обвързано с никакъв друг срок за предявяване на иск, различен от срока по ал. 1.			                                            <br><br><br><br><br>Съгласен съм и приемам условията: ............................(Подпис клиент) 
        </div>
        <div style="break-after:page"></div>
    </div>
</div>

<div id="print-label" *ngIf="modal.cntx == 'importing-contracts-burgas' && modal.obj.print_burgas_profilaktika">
    <div class="page-print-title">
        <span style="margin-right:10px;" (click)="PrintLabels()" class="right-btn">Разпечатване</span>
        <span style="margin-right:10px;" (click)="modal.obj.print_burgas_profilaktika = false;modal.open = true" class="right-btn negative">Отказ</span>
    </div>
    <div class="contract-document" *ngFor="let contract of modal.obj.contracts">
        <div class="protocol-header">
            <div class="protocol-header-logo-1"></div>
            <div class="protocol-header-logo-2 burgas"></div>
            <div class="protocol-header-logo-3"></div>
        </div>
        <span class="contract-underheader">Приложение № 4 </span>
        <span class="contract-title">
            <span>Констативен протокол </span>
            <span>за извършен годишен технически профилактичен преглед</span>
        </span>
        <div class="contract-body">
            Днес, ...................... г., в гр. Бургас, община Бургас, в изпълнение на договор № {{modal.obj.contract}} г. по рамково споразумение № 93-ОП22-22/3/17.08.2023 г.  за доставка и монтаж на ново отоплително устройство по проект BG16M1OP002-5.003-0003 „Намаляване на замърсяването на атмосферния въздух с фини прахови частици в кв. Долно Езерово, гр. Бургас“, финансиран по Оперативна програма „Околна среда“ 2014-2020 г., Приоритетна ос „Подобряване качеството на атмосферния въздух“, процедура BG16M1OP002-5.003 „Мерки за подобряване качеството на атмосферния въздух“, се подписа  настоящия констативен протокол, с който се удостоверява, че е извършен технически профилактичен преглед на доставеното ново отоплително устройство
        </div>
        <div class="contract-list smaller">
            <ul>
                <li *ngFor="let product of contract.products; let i = index" [ngClass]="{ 'hidden':product == 0 }">Отоплително устройство {{i}}: {{ ReturnProductDescriptionById(i) }} - (марка: TREO, модел: {{ ReturnProductLabelById(i) }}) - {{product}} {{ returnProductCountLetters(product) }}</li>
            </ul>
        </div>
        <div class="contract-body">
            КРАЕН ПОЛУЧАТЕЛ {{ contract.name }} <br>
            , <span style="font-size:10px;">(попълват се трите имена)</span>, заявление № {{ contract.contract }}
        </div>
        <div class="contract-body">
            1. При техническия профилактичен преглед се установи следното:
            <span style='font-size:10px;'>(Посочват се констатации относно дали: отоплителното устройство е налично, в цялост и в изправност, дали е използвано съгласно инструкциите за експлоатация и поддържа, вкл. относно препоръките на производителя, дали са извършвани неоторизирани ремонти)</span>
        </div>
        <div class="warranties-confirm smaller">
            <span>1.1 Наличие на климатична система </span>
            <div class="warranties-field-check" style="float:right">
                <div class="check"></div>
                <span>НЕ</span>
            </div>
            <div class="warranties-field-check" style="float:right">
                <div class="check"></div>
                <span>ДА</span>
            </div>
        </div>
        <div class="warranties-confirm smaller">
            <span>1.2 Изправна  климатична система, тест на режими на работа. </span>
            <div class="warranties-field-check" style="float:right">
                <div class="check"></div>
                <span>НЕ</span>
            </div>
            <div class="warranties-field-check" style="float:right">
                <div class="check"></div>
                <span>ДА</span>
            </div>
        </div>
        <div class="warranties-confirm smaller">
            <span>1.3 Общо състояние на климатичната система в съотвествие с изискванията на производителя: </span>
        </div>
        <div class="warranties-confirm smaller">
            <span>- Чистота        </span>
            <div class="warranties-field-check" style="float:right">
                <div class="check"></div>
                <span>НЕ</span>
            </div>
            <div class="warranties-field-check" style="float:right">
                <div class="check"></div>
                <span>ДА</span>
            </div>
        </div>
        <div class="warranties-confirm smaller">
            <span>- Следи от неоторизиран ремонт         </span>
            <div class="warranties-field-check" style="float:right">
                <div class="check"></div>
                <span>НЕ</span>
            </div>
            <div class="warranties-field-check" style="float:right">
                <div class="check"></div>
                <span>ДА</span>
            </div>
        </div>
        <div class="warranties-confirm smaller">
            <span>2. Препоръки към крайния получател: </span>
        </div>
        <div class="warranties-confirm smaller">
            <span>2.1 За профилактично почистване </span>
            <div class="warranties-field-check" style="float:right">
                <div class="check"></div>
                <span>НЕ</span>
            </div>
            <div class="warranties-field-check" style="float:right">
                <div class="check"></div>
                <span>ДА</span>
            </div>
        </div>
        <div class="warranties-confirm smaller">
            <span>2.2 За ремонт</span>
            <div class="warranties-field-check" style="float:right">
                <div class="check"></div>
                <span>НЕ</span>
            </div>
            <div class="warranties-field-check" style="float:right">
                <div class="check"></div>
                <span>ДА</span>
            </div>
        </div>
        <div class="contract-body">
            Настоящият протокол се подписа в три еднообразни екземпляра – един за КРАЙНИЯ ПОЛУЧАТЕЛ, един за Изпълнителя и един за Възложителя.
        </div>
        <table class="contract-second-sign">
            <tr>
                <td>ИЗПЪЛНИТЕЛ: </td>
                <td>КРАЕН ПОЛУЧАТЕЛ: </td>
            </tr>
            <tr>
                <td>Георги Топалов </td>
                <td>(име и подпис) </td>
            </tr>
        </table>
        <hr style="float:left;width:80%;margin-left:10%;">
        <div class="contract-body" style="margin-top:0px;">
            <span style="font-size: 12px;text-align: center;float: left;width: 100%;">Този документ е изготвен в рамките на проект BG16M1OP002-5.003-0003 „Намаляване на замърсяването на атмосферния въздух с фини прахови частици в кв. Долно Езерово, гр. Бургас“,АДБФП №  BG16M1OP002-5.003-0003-C02, финансиран по Оперативна програма „Околна среда“ 2014-2020 г., Приоритетна ос „Подобряване качеството на атмосферния въздух“, процедура BG16M1OP002-5.003 „Мерки за подобряване качеството на атмосферния въздух“</span>
        </div>
        <div style="break-after:page"></div>
    </div>
</div>

<div id="print-label" *ngIf="modal.cntx == 'importing-contracts-burgas2026' && modal.obj.print_burgas2026_protocols">
    <div class="page-print-title">
        <span style="margin-right:10px;" (click)="PrintLabels()" class="right-btn">Разпечатване</span>
        <span style="margin-right:10px;" (click)="modal.obj.print_burgas2026_protocols = false;modal.open = true" class="right-btn negative">Отказ</span>
    </div>
    <div class="contract-document burgas2026-page" *ngFor="let contract of modal.obj.contracts">
        <div class="burgas2026-page-main">
            <div class="protocol-header burgas2026">
                <div class="protocol-header-logo-1"></div>
                <div class="protocol-header-logo-2"></div>
                <div class="protocol-header-logo-3"></div>
            </div>
            <span class="contract-title">
                <span>Приемо-предавателен протокол за доставка и монтаж</span>
                <span>на ново отоплително устройство и отоплителна инсталация</span>
            </span>
            <div class="contract-body">
                Днес, ............................ г., в гр. Бургас, община Бургас, в изпълнение на Договор № {{modal.obj.contract}} за доставка и монтаж на ново отоплително устройство по проект BG16FFPR002-5.001-0007 „Намаляване на замърсяването на атмосферния въздух с фини прахови частици в населените места на Община Бургас - II“, финансиран по Програма „Околна среда“ 2021-2027, приоритетна ос 5 «Въздух», процедура BG16FFPR002-5.001 „За по-чист въздух!“, се подписа настоящия приемо-предавателен протокол, с който се удостоверява, че КРАЙНИЯТ ПОЛУЧАТЕЛ по договора <br><br><span style="font-weight:bold;font-size:16px;">{{ contract.name }}</span> <br><span style="font-size:10px;">(попълват се трите имена)</span><br><br> получи безвъзмездно:
            </div>
            <div class="contract-list">
                <span>доставка и монтаж на ново/и отоплително/и устройство/а:</span>
                <ul>
                    <li *ngFor="let product of contract.products">{{ ReturnBurgas2026Mapped(product).catalog_description }} - (марка: {{ ReturnBurgas2026Mapped(product).brand }}, модел: {{ ReturnBurgas2026Mapped(product).label }}) - {{product.count}} {{ returnProductCountLetters(product.count) }}</li>
                </ul>
                <Span style="margin-top:10px;">в следния недвижим имот, собственост на КРАЙНИЯ ПОЛУЧАТЕЛ: жилищна сграда, с адрес: <br><br><span style="font-weight:bold;font-size:16px;">{{ contract.address }}</span><br><br></Span>
            </div>
            <div class="contract-body">
                2. гаранционна карта за двегодишна гаранция и гаранционен сервиз на отоплителното устройство по т. 1, считано от датата на подписване на настоящия приемо-предавателен протокол;<br>
                3. писмени инструкции за експлоатация и поддръжка на новото отоплително устройство на български език;<br>
                4. инструктаж на място при доставката и монтажа на новото отоплително устройство за неговата правилна експлоатация и поддръжка.<br>
                Настоящият протокол се подписа в три еднообразни екземпляра – един за КРАЙНИЯ ПОЛУЧАТЕЛ, един за Изпълнителя и един за Възложителя.
            </div>
        </div>
        <div class="burgas2026-page-signs">
            <table class="contract-second-sign">
                <tr>
                    <td>ИЗПЪЛНИТЕЛ (за предал): </td>
                    <td>КРАЕН ПОЛУЧАТЕЛ (за приел): </td>
                </tr>
                <tr>
                    <td>Красимира Жилева </td>
                    <td>(име и подпис) </td>
                </tr>
            </table>
        </div>
        <div class="burgas2026-page-footer">
            Този документ е изготвен в рамките на проект BG16FFPR002-5.001-0007 „Намаляване на замърсяването на атмосферния въздух с фини прахови частици в населените места на Община Бургас - II“, финансиран по Програма „Околна среда“ 2021-2027, приоритетна ос 5 «Въздух», процедура BG16FFPR002-5.001 „За по-чист въздух!“
        </div>
    </div>
</div>

<div id="print-label" *ngIf="modal.cntx == 'importing-contracts-burgas2026' && modal.obj.print_burgas2026_warranties">
    <div class="page-print-title">
        <span style="margin-right:10px;" (click)="PrintLabels()" class="right-btn">Разпечатване</span>
        <span style="margin-right:10px;" (click)="modal.obj.print_burgas2026_warranties = false;modal.open = true" class="right-btn negative">Отказ</span>
    </div>
    <div class="contract-document warranty" *ngFor="let contract of modal.obj.contracts">
        <div style="float:left;width:100vw;height:100vh;">
            <div class="warranties-print-header">
                <div class="warranties-print-header-title" style="margin-left:160px;">
                    <span>ГАРАНЦИОННА КАРТА № {{ contract.contract }}</span>
                    <span>По Дог. № {{ contract.contract }}</span>
                </div>
                <div class="warranties-print-header-warranty-time">
                    <div>Гаранционен срок</div>
                    <div>{{ modal.obj.warranty_period }} месеца</div>
                </div>
            </div>
            <table border="1" cellspacing="0" cellpadding="0" class="warranties-standard-table">
                <tbody>
                    <tr>
                        <td>Инсталационна компания<br>
                            (оторизиран гаранционен сервиз)</td>
                        <td>
                            „ТЕМПЕКС” ЕООД – 032 390 102 / warranty@tempexbg.com<br>
                            Дата на подписване ППП ………………
                        </td>
                    </tr>
                    <tr>
                        <td>Имена на клиента</td>
                        <td>{{ contract.name }}</td>
                    </tr>
                    <tr>
                        <td>Телефон на клиента</td>
                        <td>{{ contract.phone }}</td>
                    </tr>
                    <tr>
                        <td>Адрес на клиента</td>
                        <td>{{ contract.address }}</td>
                    </tr>
                    <tr>
                        <td>по проект ОПОС 2021-2027 Договор</td>
                        <td>{{ modal.obj.contract }}</td>
                    </tr>
                </tbody>
            </table>
            <table class="warranties-product-table" border="1" cellpadding="0" cellspacing="0">
                <tr>
                    <td>I.</td>
                    <td colspan="4">Данни на Уреда</td>
                </tr>
                <tr>
                    <td width="5%">Бр.</td>
                    <td width="40%">Мощност в KW (охл./отопл.)</td>
                    <td>Сериен №<br>
                        вътрешно тяло</td>
                    <td>Сериен №<br>
                        външно тяло</td>
                </tr>
                <tr *ngFor="let product of contract.products">
                    <td width="5%">{{ product.count }}</td>
                    <td width="40%">{{ ReturnBurgas2026Mapped(product).catalog_description }} - (Марка - {{ ReturnBurgas2026Mapped(product).brand }}, Модел - {{ ReturnBurgas2026Mapped(product).label }})</td>
                    <td></td>
                    <td></td>
                </tr>
            </table>
            <table class="warranties-product-table" border="1" cellpadding="0" cellspacing="0">
                <tr>
                    <td width="5%">II.</td>
                    <td colspan="2">Допълнителни особености на монтажа</td>
                </tr>
                <tr>
                    <td width="5%">1.</td>
                    <td width="55%"></td>
                    <td></td>
                </tr>
            </table>
            <table class="warranties-product-table" border="1" cellpadding="0" cellspacing="0">
                <tr>
                    <td width="5%">III.</td>
                    <td style="width:35%">Технически прегледи</td>
                    <td style="width:20%">Дата</td>
                    <td>Сервизен техник подпис</td>
                </tr>
                <tr>
                    <td width="5%">1.</td>
                    <td style="width:35%">Технически преглед след първата година</td>
                    <td style="width:20%"></td>
                    <td></td>
                </tr>
            </table>
            <div class="warranties-confirm">
                <span>Съгласен съм с извършените СМР: </span>
                <div class="warranties-field-check">
                    <div class="check"></div>
                    <span>ДА</span>
                </div>
                <div class="warranties-field-check">
                    <div class="check"></div>
                    <span>НЕ</span>
                </div>
            </div>
            <table class="warranties-notes">
                <tr>
                    <td>Забележка: НЯМА</td>
                    <td>Подпис монтажник: ........................      Подпис клиент: .......................</td>
                </tr>
                <tr>
                    <td colspan="2">Контакти: гр.Пловдив, бул.Кукленско шосе 52, тел. 032 390 102, warranty@tempexbg.com</td>
                </tr>
            </table>
        </div>
        <div class="warranties-rights">
        <span>IV. ГАРАНЦИОННИ УСЛОВИЯ</span>
1. Гаранционният срок на изделието е {{modal.obj.warranty_period}} месеца и започва да тече от подписването на приемо-предавателен протокол за доставка, монтаж и въвеждане в експлоатация, подписан от Изпълнителя и от крайния получател (или негов пълномощник) в три екземпляра.
<br>2. Гаранционният срок е валиден при заявена предварително от Крайния получател и осъществена по график от Изпълнителя профилактика в интервала от 15 май - 15 септември. При годишната профилактика се извършва пълно обслужване и замерване параметрите на климатика. При отклонение от нормалната работа се предприемат съответните мерки.
<br>Внимание: Повредена, неправилно или непълно попълнена гаранционна карта е невалидна! На загубена или увредена гаранционна карта дубликат не се издава.
<br>3. В рамките на гаранционния срок изпълнителят се задължава да отстранява появили се скрити недостатъци и/или такива, настъпили вследствие на извършения монтаж, ако недостатъкът не може да бъде отстранен/отремонтиран, устройството се заменя с ново.
<br>4. В случай на възникнала необходимост от ремонт на устройствата, разходите за демонтаж, монтаж, зареждане с хладилен агент, транспорт и други съпътстващи са за сметка на изпълнителя.
<br>5. Гаранционното обслужване е безплатно за неизправностите, вследствие на фабричен дефект.
<br>6. Гаранцията се отнася за повреди, възникнали в процеса на правилната експлоатация /съгласно Инструкцията за употреба на съответния модел/ през гаранционния период. Всички такива повреди се отстраняват безплатно.
БЕЗПЛАТЕН ГАРАНЦИОНЕН СЕРВИЗ СЕ ОТКАЗВА В СЛЕДНИТЕ СЛУЧАИ:
<br>- подправени, непълно или неточно попълнени данни в гаранционната карта на оборудването;
<br>- не са спазени условията за съхранение и експлоатация, посочени в упътването на продукта;
<br>- когато е правен опит за отстраняване на повредата от неупълномощени лица;
<br>- не е заявена и извършена годишна профилактика за втората и всяка следваща година;
<br>- при сътресения, удари и претоварвания вследствие на небрежно отношение;
<br>- когато повредата е причинена от природно бедствие, токов удар, неизправност в захранващата мрежа или други форсмажорни обстоятелства.
НА ГАРАНЦИЯ НЕ ПОДЛЕЖАТ:
<br>-дистанционното управление; - пластмасовите части,въздушни филтри, антибактериални филтри; -пластмасовите части; - почистването на инсталацията, филтрите на вътрешното тяло, отпушване на кондензен маркуч.
Внимание: Преди да се отнесете към сервиза проверете в Инструкцията дали не е описан Вашия проблем.
Клиентът е длъжен да осигури свободен достъп на сервизните специалисти до климатизатора.
Когато при диагностика, включително и на гаранционен климатизатор се установи, че същия е изправен и техническите му параметри са в нормите,  зададени от производителя, клиентът е длъжен да заплати направените разходи от сервизните специалисти по утвърден ценоразпис.
ОСЪЩЕСТВЯВАНЕ НА ГАРАНЦИЯТА:
<br>- В случай на повреда на оборудването в неговия гаранционен срок, представител на Възложителя или крайния получател на оборудването отправя съобщение до изпълнителя. Съобщението може да бъде изпратено по факс, електронна поща или обикновена поща.
<br>- Повредата на климатизатора в рамките на гаранционния срок не е основание за подмяна с нов. Не се ангажираме с допустим максимален брой ремонти, които да налагат замяната на определена стока с нова;- Посещение на специалист по заявка на клиента и липса на гаранционен дефект или неспазени условия се заплаща от клиента;
<br>- Вносителят и изпълнителят не са отговорни за пропуснати ползи и последвали загуби, в следствие на дефектна стока и престоя й в сервиза, както и да осигуряват оборотно друга стока. Не се обвързваме с допустим максимален брой ремонти, което да налага замяна на климатичната инсталация с нова.
ПРАВА НА ПОТРЕБИТЕЛЯТ ПО ЗАКОНА ЗА ЗАЩИТА НА ПОТРЕБИТЕЛИТЕ
Съгласно чл. 112 от ЗЗП, потребителят има следните права:
При несъответствие на продукта със сделката за продажба, потребителят има право да предяви рекламация, като поиска от Продавача да приведе стоката в съответствие със сделката за продажба. В този случай Потребителят може да избира между извършване на ремонт на стоката или размяната й с нова, освен ако това е невъзможно или избраният от него начин на обезщетение е непропорционален в сравнение с другия. Смята се, че даден начин за обезщетяване на Потребителя е непропорционален, ако неговото използване налага разходи на Продавача, които в сравнение с другия начин на обезщетяване са неразумни, като се вземат предвид: стойността на потребителската стока ако няма липса на несъответствие; значимостта на несъответствието, възможността да се предложи на Потребителя друг начин на обезщетяване, който не е свързан със значителни неудобства за него.
Съгласно чл. 113 от ЗЗП, потребителят има следните права:
<br>- Когато продуктът не съответства на сделката за продажба, Продавачът е длъжен да я приведе в съответствие със сделката за продажба;
<br>- Привеждането на продукта в съответствие със сделката за продажба трябва да се извърши в рамките на един месец, считано от предявяването на рекламация от потребителя;
<br>- След изтичането на срока по ал. 2 Потребителят има право да развали сделката и да му бъде възстановена заплатената сума или да иска намаляване на цената на потребителската стока съгласно чл. 114 от ЗЗП;
<br>- Привеждането на продукта в съответствие със сделката за продажба е безплатно за потребителя. Той не дължи разходи за екстрадирането на потребителската стока или за материали и труд, свързани с ремонта й и не трябва да понася значителни неудобства;- Потребителят може да иска и обезщетение за претърпените в последствие на несъответствието вреди.
Съгласно чл. 114 от ЗЗП, потребителят има следните права:
<br>- При несъответствие на продукта с на продажба и когато Потребителят не е удовлетворен от решаването на рекламацията по чл. 113 от ЗЗП, Потребителят има право на избор между една от следните възможности: разваляне на сделката и възстановяване на заплатената от него сума; намаляване на цента;
<br>- Потребителят не може да претендира за възстановяване на заплатената сума или за намаляване цената на продукта, когато Търговецът се съгласи да бъде извършена замяна на продукта с нов или да се поправи продукта в рамките на един месец от предявяване на рекламацията от Потребителя;
<br>- Упражняването на правото на Потребителя по ал. 1 не е обвързано с никакъв друг срок за предявяване на иск, различен от срока по ал. 1.
Съгласно чл. 115 от ЗЗП, потребителят има следните права:
<br>- Потребителят може да упражни правото си по този раздел в срок от две години, считано от доставянето на продукта;
<br>- Срокът по ал. 1 спира да тече през времето, необходимо за поправката или замяната на продукта или за постигане на споразумение между Продавача и Потребителя за решаване на спора;
<br>- Упражняването на правото на Потребителя по ал. 1 не е обвързано с никакъв друг срок за предявяване на иск, различен от срока по ал. 1.			                                            <br><br><br><br><br>Съгласен съм и приемам условията: ............................(Подпис клиент)
        </div>
        <div style="break-after:page"></div>
    </div>
</div>

<div id="print-label" *ngIf="modal.cntx == 'importing-contracts-burgas2026' && modal.obj.print_burgas2026_profilaktika">
    <div class="page-print-title">
        <span style="margin-right:10px;" (click)="PrintLabels()" class="right-btn">Разпечатване</span>
        <span style="margin-right:10px;" (click)="modal.obj.print_burgas2026_profilaktika = false;modal.open = true" class="right-btn negative">Отказ</span>
    </div>
    <div class="contract-document burgas2026-page" *ngFor="let contract of modal.obj.contracts">
        <div class="burgas2026-page-main">
            <div class="protocol-header burgas2026">
                <div class="protocol-header-logo-1"></div>
                <div class="protocol-header-logo-2"></div>
                <div class="protocol-header-logo-3"></div>
            </div>
            <span class="contract-underheader">Приложение № 4 </span>
            <span class="contract-title">
                <span>Констативен протокол</span>
                <span>за извършен годишен технически профилактичен преглед</span>
            </span>
            <div class="contract-body">
                Днес, ...................... г., в гр. Бургас, община Бургас, в изпълнение на Договор № {{modal.obj.contract}} за доставка и монтаж на ново отоплително устройство и отоплителна инсталация по проект BG16FFPR002-5.001-0007 „Намаляване на замърсяването на атмосферния въздух с фини прахови частици в населените места на Община Бургас - II“, финансиран по Програма „Околна среда“ 2021-2027, приоритетна ос 5 «Въздух», процедура BG16FFPR002-5.001 „За по-чист въздух!“, се подписа настоящия констативен протокол, с който се удостоверява, че е извършен технически профилактичен преглед на доставеното ново отоплително устройство
            </div>
            <div class="contract-list smaller">
                <ul>
                    <li *ngFor="let product of contract.products">{{ ReturnBurgas2026Mapped(product).catalog_description }} - (марка: {{ ReturnBurgas2026Mapped(product).brand }}, модел: {{ ReturnBurgas2026Mapped(product).label }}) - {{product.count}} {{ returnProductCountLetters(product.count) }}</li>
                </ul>
            </div>
            <div class="contract-body">
                КРАЕН ПОЛУЧАТЕЛ {{ contract.name }} <br>
                <span style="font-size:10px;">(попълват се трите имена)</span>, заявление № {{ contract.contract }}
            </div>
            <div class="contract-body">
                1. При техническия профилактичен преглед се установи следното:
                <span style='font-size:10px;'>(Посочват се констатации относно дали: отоплителното устройство е налично, в цялост и в изправност, дали е използвано съгласно инструкциите за експлоатация и поддържа, вкл. относно препоръките на производителя за използване на вид гориво, дали са извършвани неоторизирани ремонти)</span>
            </div>
            <div class="warranties-confirm smaller">
                <span>- отоплителното устройство е налично: </span>
                <div class="warranties-field-check" style="float:right">
                    <div class="check"></div>
                    <span>НЕ</span>
                </div>
                <div class="warranties-field-check" style="float:right">
                    <div class="check"></div>
                    <span>ДА</span>
                </div>
            </div>
            <div class="warranties-confirm smaller">
                <span>- отоплителното устройство е в цялост и в изправност: </span>
                <div class="warranties-field-check" style="float:right">
                    <div class="check"></div>
                    <span>НЕ</span>
                </div>
                <div class="warranties-field-check" style="float:right">
                    <div class="check"></div>
                    <span>ДА</span>
                </div>
            </div>
            <div class="warranties-confirm smaller">
                <span>- извършвани неоторизирани ремонти: </span>
                <div class="warranties-field-check" style="float:right">
                    <div class="check"></div>
                    <span>НЕ</span>
                </div>
                <div class="warranties-field-check" style="float:right">
                    <div class="check"></div>
                    <span>ДА</span>
                </div>
            </div>
            <div class="warranties-confirm smaller">
                <span>2. Извършени профилактични действия: </span>
                <div class="warranties-field-check" style="float:right">
                    <div class="check"></div>
                    <span>НЕ</span>
                </div>
                <div class="warranties-field-check" style="float:right">
                    <div class="check"></div>
                    <span>ДА</span>
                </div>
            </div>
            <div class="contract-body">
                Препоръки към крайния получател:<br>
                Ежемесечно почистване на филтрите.<br>
                Спазване на изискванията за експлоатация от производителя.
            </div>
            <div class="contract-body">
                Настоящият протокол се подписа в три еднообразни екземпляра – един за КРАЙНИЯ ПОЛУЧАТЕЛ, един за Изпълнителя и един за Възложителя.
            </div>
        </div>
        <div class="burgas2026-page-signs">
            <table class="contract-second-sign">
                <tr>
                    <td>ИЗПЪЛНИТЕЛ: </td>
                    <td>КРАЕН ПОЛУЧАТЕЛ: </td>
                </tr>
                <tr>
                    <td>Красимира Жилева </td>
                    <td>(име и подпис) </td>
                </tr>
            </table>
        </div>
        <div class="burgas2026-page-footer">
            Този документ е изготвен в рамките на проект BG16FFPR002-5.001-0007 „Намаляване на замърсяването на атмосферния въздух с фини прахови частици в населените места на Община Бургас - II“, финансиран по Програма „Околна среда“ 2021-2027, приоритетна ос 5 «Въздух», процедура BG16FFPR002-5.001 „За по-чист въздух!“
        </div>
    </div>
</div>

<div class="content no-subheader" *ngIf="!print_labels && !print_contracts && !print_protocols && !print_warranties">
    <input type="file" id="document-upload" style="display:none;" accept=".xlsx" (change)="onFileChange($event)" />

    <input type="file" id="document-upload-new" style="display:none;" accept=".xlsx" (change)="onFileChangeNew($event)" />
    <input type="file" id="document-upload-dimitrovgrad2026" style="display:none;" accept=".xlsx" (change)="onFileChangeDimitrovgrad2026($event)" />
    <input type="file" id="document-upload-burgas" style="display:none;" accept=".xlsx" (change)="onFileChangeBurgas($event)" />
    <input type="file" id="document-upload-burgas2026" style="display:none;" accept=".xlsx" (change)="onFileChangeBurgas2026($event)" />
    <span class="page-title">
        <span class="name" [ngClass]="{ 'underlink':chosenSection != '' }" (click)="goHome()">Други</span>
    </span>
    <div class="hint-card" *ngIf="chosenSection == ''">
        Допълнителни опции за суперпотребители
    </div>
    <div *ngIf="chosenSection == ''">
        <!-- <div class="selectable-card" *ngIf="system.returnName() == 'Илияна Христова' || system.returnName() == 'Илия Щерев' || system.returnName() == 'Пламен Петров' || system.returnName() == 'Атанас Симонов'" (click)="openFileManagement($event)">ТЪРГ ДИМИТРОВГРАД</div> -->
        <div class="selectable-card" *ngIf="system.returnName() == 'Илия Щерев' || system.returnName() == 'Пламен Петров' || system.returnName() == 'Атанас Симонов'" (click)="openFileBurgas($event)" >ТЪРГ БУРГАС</div>
        <div class="selectable-card" *ngIf="system.returnName() == 'Илия Щерев' || system.returnName() == 'Пламен Петров' || system.returnName() == 'Атанас Симонов' || system.returnName() == 'Красимира Жилева'" (click)="openFileBurgas2026($event)" >ТЪРГ БУРГАС 2026</div>
        <div class="selectable-card" *ngIf="system.returnName() == 'Илияна Христова' || system.returnName() == 'Илия Щерев' || system.returnName() == 'Пламен Петров' || system.returnName() == 'Атанас Симонов'" (click)="openModal('importing-contracts', { step:1, warranty_period:'66' })">ТЪРГ СОФИЯ</div>
        <div class="selectable-card" *ngIf="system.returnName() == 'Илияна Христова' || system.returnName() == 'Илия Щерев' || system.returnName() == 'Пламен Петров' || system.returnName() == 'Атанас Симонов'" (click)="openModal('importing-contracts-sofia', { step:1, warranty_period:'66' })">Столична община - Профилактики</div>
        <div class="selectable-card" *ngIf="system.returnName() == 'Илияна Христова' || system.returnName() == 'Илия Щерев' || system.returnName() == 'Пламен Петров'" (click)="openFileManagementNew($event)">ТЪРГ ДИМИТРОВГРАД</div>
        <div class="selectable-card" *ngIf="system.returnName() == 'Илия Щерев' || system.returnName() == 'Пламен Петров' || system.returnName() == 'Атанас Симонов' || system.returnName() == 'Красимира Жилева'" (click)="openFileManagementDimitrovgrad2026($event)">ТЪРГ ДИМИТРОВГРАД 2026</div>
        <div class="selectable-card" *ngIf="system.returnName() == 'Илия Щерев' || system.returnName() == 'Пламен Петров'" (click)="openModal('send-mass-mail', { 'layout':'', 'title':'', step:1, 'account_search':'', 'selected_emails':[], 'selected_names':[] })">ИЗПРАЩАНЕ НА МАСОВ Е-МЕЙЛ</div>
    </div>
</div>